import { createPropsActions, createActionCreator, createReducer, createPropsReducer, createPropsSelectors } from '@livechat/redux-utils';
import { compose, mergeAll, values, findKey, hasOwn, isObject, get, find, identity, mapKeys, camelCase, keyBy, getOr, fromPairs, mapValues, ensureArray, trimEnd, isNil, omit, omitBy, merge, pick, cloneDeep, forOwn, generateUniqueId, isEmpty } from '@livechat/data-utils';
import { applyMiddleware, createStore, compose as compose$1 } from 'redux';
import createSagaMiddleware, { CANCEL, buffers, delay } from 'redux-saga';
import memoryStorage, { testStorageSupport } from 'memory-web-storage';
import { removeProtocol, buildQueryString, decodeQueryString, getQueryParams } from '@livechat/url-utils';
import fetch from 'unfetch';
import fileUpload from '@livechat/file-upload';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { call, select, put, getContext, all, take, actionChannel, takeEvery, fork, race, join, cancel, spawn } from 'redux-saga/effects';
import { waitForState, _safe } from '@livechat/saga-utils';
import { get as get$1 } from '@livechat/cookies';
import { deferred } from 'redux-saga/utils';
import mitt from '@livechat/mitt';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var propsConstants = {
  LICENSE: 'license',
  GROUP: 'group',
  SESSION_ID: 'sessionId',
  SECURED_TOKEN: 'securedToken',
  CHAT_ID: 'chatId',
  CHAT_STATE: 'chatState',
  CHAT_STATUS: 'chatStatus',
  VISITOR_ID: 'visitorId',
  CUSTOM_VISITOR_ID: 'customVisitorId',
  LAST_MESSAGE_ID: 'lastMessageId',
  CONNECTION_STATUS: 'connectionStatus',
  SNEAK_PEEK: 'sneakPeek',
  TICKET_FORM: 'ticketForm',
  PRE_CHAT_FORM: 'preChatForm',
  POST_CHAT_FORM: 'postChatForm',
  STATIC_CONFIG_VERSION: 'staticConfigVersion',
  TRANSLATIONS_VERSION: 'translationsVersion',
  TRANSLATIONS: 'translations',
  SECRET_ID: 'secretId',
  REGION: 'region',
  CONFIG_LOADED: 'configLoaded',
  LAST_AGENT_ID: 'lastAgentId',
  DYNAMIC_CONFIG: 'dynamicConfig',
  CONFIG: 'config',
  WELCOME_MESSAGE: 'welcomeMessage',
  ACCEPTED_INVITATION: 'acceptedInvitation',
  SERVER_IDS_MAP: 'serverIdsMap',
  VISITOR_CUSTOM_ID_MAP: 'visitorCustomIdMap',
  CLIENT_LIMIT_EXCEEDED: 'clientLimitExceeded',
  PING_SENT: 'pingSent',
  CHAT_BETWEEN_GROUPS: 'chatBetweenGroups',
  HISTORY_LOADED: 'historyLoaded',
  REQUEST_DISTRIBUTION: 'requestDistribution',
  MOBILE: 'mobile'
};

var propsActions = _extends({}, createPropsActions(propsConstants.LICENSE), createPropsActions(propsConstants.GROUP), createPropsActions(propsConstants.SESSION_ID), createPropsActions(propsConstants.SECURED_TOKEN), createPropsActions(propsConstants.CHAT_ID), createPropsActions(propsConstants.CHAT_STATE), createPropsActions(propsConstants.VISITOR_ID), createPropsActions(propsConstants.CUSTOM_VISITOR_ID), createPropsActions(propsConstants.LAST_MESSAGE_ID), createPropsActions(propsConstants.CHAT_STATUS), createPropsActions(propsConstants.CONNECTION_STATUS), createPropsActions(propsConstants.SNEAK_PEEK), createPropsActions(propsConstants.TICKET_FORM), createPropsActions(propsConstants.STATIC_CONFIG_VERSION), createPropsActions(propsConstants.SECRET_ID), createPropsActions(propsConstants.REGION), createPropsActions(propsConstants.CONFIG_LOADED), createPropsActions(propsConstants.LAST_AGENT_ID), createPropsActions(propsConstants.PRE_CHAT_FORM), createPropsActions(propsConstants.TRANSLATIONS_VERSION), createPropsActions(propsConstants.TRANSLATIONS), createPropsActions(propsConstants.POST_CHAT_FORM), createPropsActions(propsConstants.CONFIG), createPropsActions(propsConstants.DYNAMIC_CONFIG), createPropsActions(propsConstants.WELCOME_MESSAGE), createPropsActions(propsConstants.ACCEPTED_INVITATION), createPropsActions(propsConstants.SERVER_IDS_MAP), createPropsActions(propsConstants.VISITOR_CUSTOM_ID_MAP), createPropsActions(propsConstants.CLIENT_LIMIT_EXCEEDED), createPropsActions(propsConstants.PING_SENT), createPropsActions(propsConstants.CHAT_BETWEEN_GROUPS), createPropsActions(propsConstants.HISTORY_LOADED), createPropsActions(propsConstants.REQUEST_DISTRIBUTION), createPropsActions(propsConstants.MOBILE));

var CHAT_STARTED = 'CHAT_STARTED';
var NEW_MESSAGE = 'NEW_MESSAGE';
var CHAT_ENDED = 'CHAT_ENDED';
var NEW_AGENT = 'NEW_AGENT';
var VISITOR_DATA_SET = 'VISITOR_DATA_SET';
var VISITOR_DATA_SET_ERROR = 'VISITOR_DATA_SET_ERROR';
var NEW_FILE = 'NEW_FILE';
var VISITOR_QUEUED = 'VISITOR_QUEUED';
var TYPING_INDICATOR = 'TYPING_INDICATOR';
var RATE_CHAT = 'RATE_CHAT';
var SET_VISITOR_DATA = 'SET_VISITOR_DATA';
var SEND_FILE = 'SEND_FILE';
var REQUEST_FILE_TOKEN = 'REQUEST_FILE_TOKEN';
var FILE_TOKEN_RECEIVED = 'FILE_TOKEN_RECEIVED';
var NEW_INVITATION = 'NEW_INVITATION';
var MESSAGE_SEEN = 'MESSAGE_SEEN';
var PROTOCOL_UPGRADED = 'PROTOCOL_UPGRADED';
var INTEGRATION_DATA = 'INTEGRATION_DATA';
var chatStarted = createActionCreator(CHAT_STARTED, function (_ref) {
  var securedToken = _ref.securedToken,
      welcomeMessage = _ref.welcomeMessage,
      visitorMessage = _ref.visitorMessage;
  return {
    securedToken: securedToken,
    welcomeMessage: welcomeMessage,
    visitorMessage: visitorMessage
  };
});
var newMessage = createActionCreator(NEW_MESSAGE, function (_ref2) {
  var id = _ref2.id,
      timestamp = _ref2.timestamp,
      authorType = _ref2.authorType,
      authorId = _ref2.authorId,
      text = _ref2.text,
      chatId = _ref2.chatId,
      isMobile = _ref2.isMobile,
      customId = _ref2.customId,
      serverId = _ref2.serverId,
      json = _ref2.json;
  return {
    id: id,
    timestamp: timestamp,
    authorType: authorType,
    authorId: authorId,
    text: text,
    chatId: chatId,
    isMobile: isMobile,
    customId: customId,
    serverId: serverId,
    json: json
  };
});
var chatEnded = createActionCreator(CHAT_ENDED, function (_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      reason = _ref3.reason;

  return {
    reason: reason
  };
});
var newAgent = createActionCreator(NEW_AGENT, function (_ref4) {
  var avatarUrl = _ref4.avatarUrl,
      jobTitle = _ref4.jobTitle,
      name = _ref4.name,
      id = _ref4.id,
      _ref4$fromInvitation = _ref4.fromInvitation,
      fromInvitation = _ref4$fromInvitation === void 0 ? false : _ref4$fromInvitation;
  return {
    avatarUrl: avatarUrl,
    jobTitle: jobTitle,
    name: name,
    id: id,
    fromInvitation: fromInvitation
  };
});
var visitorDataSet = createActionCreator(VISITOR_DATA_SET, function (_ref5) {
  var visitorData = _ref5.visitorData,
      requestId = _ref5.requestId;
  return {
    visitorData: visitorData,
    requestId: requestId
  };
});
var visitorDataSetError = createActionCreator(VISITOR_DATA_SET_ERROR, function (_ref6) {
  var error = _ref6.error,
      requestId = _ref6.requestId;
  return {
    error: error,
    requestId: requestId
  };
});
var newFile = createActionCreator(NEW_FILE, function (_ref7) {
  var id = _ref7.id,
      timestamp = _ref7.timestamp,
      authorType = _ref7.authorType,
      authorId = _ref7.authorId,
      url = _ref7.url,
      contentType = _ref7.contentType,
      size = _ref7.size,
      attachmentToken = _ref7.attachmentToken,
      thumbnail = _ref7.thumbnail;
  return {
    id: id,
    timestamp: timestamp,
    authorType: authorType,
    authorId: authorId,
    url: url,
    size: size,
    contentType: contentType,
    attachmentToken: attachmentToken,
    thumbnail: thumbnail
  };
});
var visitorQueued = createActionCreator(VISITOR_QUEUED, function (_ref8) {
  var numberInQueue = _ref8.numberInQueue,
      waitingTime = _ref8.waitingTime;
  return {
    numberInQueue: numberInQueue,
    waitingTime: waitingTime
  };
});
var typingIndicator = createActionCreator(TYPING_INDICATOR, function (_ref9) {
  var authorId = _ref9.authorId,
      isTyping = _ref9.isTyping;
  return {
    authorId: authorId,
    isTyping: isTyping
  };
});
var rateChat = createActionCreator(RATE_CHAT, function (_ref10) {
  var rate = _ref10.rate,
      comment = _ref10.comment;
  return {
    rate: rate,
    comment: comment
  };
});
var setVisitorData = createActionCreator(SET_VISITOR_DATA, function (_ref11) {
  var visitorData = _ref11.visitorData,
      requestId = _ref11.requestId,
      _ref11$internal = _ref11.internal,
      internal = _ref11$internal === void 0 ? false : _ref11$internal;
  return {
    visitorData: visitorData,
    requestId: requestId,
    internal: internal
  };
});
var sendFile = createActionCreator(SEND_FILE, function (_ref12) {
  var file = _ref12.file,
      customId = _ref12.customId;
  return {
    file: file,
    customId: customId
  };
});
var requestFileToken = createActionCreator(REQUEST_FILE_TOKEN, function (_ref13) {
  var customId = _ref13.customId;
  return {
    customId: customId
  };
});
var fileTokenReceived = createActionCreator(FILE_TOKEN_RECEIVED, function (_ref14) {
  var customId = _ref14.customId,
      token = _ref14.token;
  return {
    customId: customId,
    token: token
  };
});
var newInvitation = createActionCreator(NEW_INVITATION, function (_ref15) {
  var id = _ref15.id,
      authorId = _ref15.authorId,
      text = _ref15.text,
      receivedFirstTime = _ref15.receivedFirstTime;
  return {
    id: id,
    authorId: authorId,
    text: text,
    receivedFirstTime: receivedFirstTime
  };
});
var messageSeen = createActionCreator(MESSAGE_SEEN, function (_ref16) {
  var id = _ref16.id,
      customId = _ref16.customId,
      type = _ref16.type;
  return {
    id: id,
    customId: customId,
    type: type
  };
});
var protocolUpgraded = createActionCreator(PROTOCOL_UPGRADED, function () {});
var integrationData = createActionCreator(INTEGRATION_DATA, function (_ref17) {
  var id = _ref17.id,
      timestamp = _ref17.timestamp,
      integrationName = _ref17.integrationName,
      data = _ref17.data;
  return {
    id: id,
    timestamp: timestamp,
    integrationName: integrationName,
    data: data
  };
});

var chatActions = /*#__PURE__*/Object.freeze({
  chatStarted: chatStarted,
  newMessage: newMessage,
  chatEnded: chatEnded,
  newAgent: newAgent,
  visitorDataSet: visitorDataSet,
  visitorDataSetError: visitorDataSetError,
  newFile: newFile,
  visitorQueued: visitorQueued,
  typingIndicator: typingIndicator,
  rateChat: rateChat,
  setVisitorData: setVisitorData,
  sendFile: sendFile,
  requestFileToken: requestFileToken,
  fileTokenReceived: fileTokenReceived,
  newInvitation: newInvitation,
  messageSeen: messageSeen,
  protocolUpgraded: protocolUpgraded,
  integrationData: integrationData
});

var _setVisitorDetailsRed;
var initialState = {};
var reducers = compose(mergeAll, function (props) {
  return props.map(createPropsReducer);
}, values)(propsConstants);
var selectors = compose(mergeAll, function (props) {
  return props.map(createPropsSelectors);
}, values)(propsConstants);
var propsSelectors = selectors;
var getEnvironment = function getEnvironment(state) {
  return state.environment;
};
var setVisitorDetailsReducer = (_setVisitorDetailsRed = {}, _setVisitorDetailsRed[setVisitorData.getActionName()] = function (state, action) {
  return _extends({}, state, {
    visitorData: action.visitorData
  });
}, _setVisitorDetailsRed);
var getVisitorData = function getVisitorData(state) {
  return state.visitorData;
};
var rootReducer = createReducer(initialState, _extends({}, setVisitorDetailsReducer, reducers));

var configureStore = function configureStore(initialState$$1, _ref) {
  var external = _ref.external;
  var sagaMiddleware = createSagaMiddleware({
    context: {
      external: external
    }
  });
  var finalCreateStore = compose$1(applyMiddleware(sagaMiddleware), window.devToolsExtension ? window.devToolsExtension() : function (fn) {
    return fn;
  })(createStore);
  var store = finalCreateStore(rootReducer, initialState$$1);
  store.runSaga = sagaMiddleware.run;
  return store;
};

var PUBLIC_SEND_MESSAGE = 'PUBLIC_SEND_MESSAGE';
var PUBLIC_INIT = 'PUBLIC_INIT';
var PUBLIC_GET_VISITOR_DATA = 'GET_VISITOR_DATA';
var PUBLIC_SET_VISITOR_DATA = 'PUBLIC_SET_VISITOR_DATA';
var PUBLIC_CALLBACK_ERROR = 'PUBLIC_CALLBACK_ERROR';
var PUBLIC_RATE_CHAT = 'PUBLIC_RATE_CHAT';
var PUBLIC_SET_SNEAK_PEEK = 'PUBLIC_SET_SNEAK_PEEK';
var PUBLIC_FORWARD_CHAT_TRANSCRIPT = 'PUBLIC_FORWARD_CHAT_TRANSCRIPT';
var PUBLIC_CLOSE_CHAT = 'PUBLIC_CLOSE_CHAT';
var PUBLIC_DISCONNECT = 'PUBLIC_DISCONNECT';
var PUBLIC_GET_TICKET_FORM = 'PUBLIC_GET_TICKET_FORM';
var PUBLIC_SEND_TICKET_FORM = 'PUBLIC_SEND_TICKET_FORM';
var PUBLIC_SEND_FILE = 'PUBLIC_SEND_FILE';
var PUBLIC_CANCEL_SEND_FILE = 'PUBLIC_SEND_FILE';
var PUBLIC_GET_PRECHAT_FORM = 'PUBLIC_GET_PRECHAT_FORM';
var PUBLIC_SEND_PRECHAT_FORM = 'PUBLIC_SEND_PRECHAT_FORM';
var PUBLIC_GET_TRANSLATIONS = 'PUBLIC_GET_TRANSLATIONS';
var PUBLIC_GET_PREDICTED_AGENT = 'PUBLIC_GET_PREDICTED_AGENT';
var PUBLIC_GET_POSTCHAT_FORM = 'PUBLIC_GET_POSTCHAT_FORM';
var PUBLIC_SEND_POSTCHAT_FORM = 'PUBLIC_SEND_POSTCHAT_FORM';
var PUBLIC_GET_CONFIG = 'PUBLIC_GET_CONFIG';
var PUBLIC_ACCEPT_INVITATION = 'PUBLIC_ACCEPT_INVITATION';
var PUBLIC_MESSAGE_AS_SEEN = 'PUBLIC_MESSAGE_AS_SEEN';
var PUBLIC_START_CHAT = 'PUBLIC_START_CHAT';
var PUBLIC_CHECK_GROUP_STATUS = 'PUBLIC_CHECK_GROUP_STATUS';
var PUBLIC_SET_VISITOR_GROUP = 'PUBLIC_SET_VISITOR_GROUP';
var PUBLIC_GET_QUEUE_FORM = 'PUBLIC_GET_QUEUE_FORM';
var publicSendMessage = createActionCreator(PUBLIC_SEND_MESSAGE, function (_ref) {
  var customId = _ref.customId,
      text = _ref.text,
      json = _ref.json,
      promise = _ref.promise;
  return {
    customId: String(customId),
    text: text,
    json: json,
    promise: promise
  };
});
var publicInit = createActionCreator(PUBLIC_INIT, function (_ref2) {
  var license = _ref2.license,
      group = _ref2.group;
  return {
    license: license,
    group: group
  };
});
var publicSetVisitorData = createActionCreator(PUBLIC_SET_VISITOR_DATA, function (_ref3) {
  var name = _ref3.name,
      email = _ref3.email,
      pageUrl = _ref3.pageUrl,
      pageTitle = _ref3.pageTitle,
      customProperties = _ref3.customProperties,
      promise = _ref3.promise,
      _ref3$update = _ref3.update,
      update = _ref3$update === void 0 ? true : _ref3$update;
  return {
    name: name,
    email: email,
    customProperties: customProperties,
    pageUrl: pageUrl,
    pageTitle: pageTitle,
    promise: promise,
    update: update
  };
});
var publicGetVisitorData = createActionCreator(PUBLIC_GET_VISITOR_DATA, function (_ref4) {
  var promise = _ref4.promise;
  return {
    promise: promise
  };
});
var publicCallbackError = createActionCreator(PUBLIC_CALLBACK_ERROR, function (_ref5) {
  var errorMessage = _ref5.errorMessage;
  return {
    errorMessage: errorMessage
  };
});
var publicRateChat = createActionCreator(PUBLIC_RATE_CHAT, function (_ref6) {
  var rate = _ref6.rate,
      comment = _ref6.comment,
      promise = _ref6.promise;
  return {
    rate: rate,
    comment: comment,
    promise: promise
  };
});
var publicSetSneakPeek = createActionCreator(PUBLIC_SET_SNEAK_PEEK, function (_ref7) {
  var text = _ref7.text,
      promise = _ref7.promise;
  return {
    text: text,
    promise: promise
  };
});
var publicForwardChatTranscript = createActionCreator(PUBLIC_FORWARD_CHAT_TRANSCRIPT, function (_ref8) {
  var email = _ref8.email,
      promise = _ref8.promise;
  return {
    email: email,
    promise: promise
  };
});
var publicCloseChat = createActionCreator(PUBLIC_CLOSE_CHAT, function (_ref9) {
  var promise = _ref9.promise;
  return {
    promise: promise
  };
});
var publicDisconnect = createActionCreator(PUBLIC_DISCONNECT, function (_ref10) {
  var promise = _ref10.promise;
  return {
    promise: promise
  };
});
var publicGetTicketForm = createActionCreator(PUBLIC_GET_TICKET_FORM, function (_ref11) {
  var promise = _ref11.promise,
      group = _ref11.group;
  return {
    promise: promise,
    group: group
  };
});
var publicSendTicketForm = createActionCreator(PUBLIC_SEND_TICKET_FORM, function (_ref12) {
  var answers = _ref12.answers,
      promise = _ref12.promise;
  return {
    answers: answers,
    promise: promise
  };
});
var publicSendFile = createActionCreator(PUBLIC_SEND_FILE, function (_ref13) {
  var file = _ref13.file,
      customId = _ref13.customId,
      promise = _ref13.promise,
      onProgress = _ref13.onProgress;
  return {
    file: file,
    customId: customId,
    promise: promise,
    onProgress: onProgress
  };
});
var publicCancelSendFile = createActionCreator(PUBLIC_CANCEL_SEND_FILE, function (_ref14) {
  var customId = _ref14.customId;
  return {
    customId: customId
  };
});
var publicGetPrechatForm = createActionCreator(PUBLIC_GET_PRECHAT_FORM, function (_ref15) {
  var promise = _ref15.promise;
  return {
    promise: promise
  };
});
var publicSendPrechatForm = createActionCreator(PUBLIC_SEND_PRECHAT_FORM, function (_ref16) {
  var promise = _ref16.promise,
      answers = _ref16.answers;
  return {
    promise: promise,
    answers: answers
  };
});
var publicGetTranslations = createActionCreator(PUBLIC_GET_TRANSLATIONS, function (_ref17) {
  var promise = _ref17.promise;
  return {
    promise: promise
  };
});
var publicGetPredictedAgent = createActionCreator(PUBLIC_GET_PREDICTED_AGENT, function (_ref18) {
  var promise = _ref18.promise;
  return {
    promise: promise
  };
});
var publicGetPostChatForm = createActionCreator(PUBLIC_GET_POSTCHAT_FORM, function (_ref19) {
  var promise = _ref19.promise;
  return {
    promise: promise
  };
});
var publicSendPostChatForm = createActionCreator(PUBLIC_SEND_POSTCHAT_FORM, function (_ref20) {
  var promise = _ref20.promise,
      answers = _ref20.answers;
  return {
    promise: promise,
    answers: answers
  };
});
var publicGetConfig = createActionCreator(PUBLIC_GET_CONFIG, function (_ref21) {
  var promise = _ref21.promise;
  return {
    promise: promise
  };
});
var publicAcceptInvitation = createActionCreator(PUBLIC_ACCEPT_INVITATION, function (_ref22) {
  var promise = _ref22.promise,
      id = _ref22.id;
  return {
    promise: promise,
    id: id
  };
});
var publicMarkMessageAsSeen = createActionCreator(PUBLIC_MESSAGE_AS_SEEN, function (_ref23) {
  var promise = _ref23.promise,
      messageId = _ref23.messageId;
  return {
    promise: promise,
    messageId: messageId
  };
});
var publicStartChat = createActionCreator(PUBLIC_START_CHAT, function (_ref24) {
  var promise = _ref24.promise;
  return {
    promise: promise
  };
});
var publicCheckGroupStatus = createActionCreator(PUBLIC_CHECK_GROUP_STATUS, function (_ref25) {
  var group = _ref25.group,
      promise = _ref25.promise;
  return {
    group: group,
    promise: promise
  };
});
var publicSetVisitorGroup = createActionCreator(PUBLIC_SET_VISITOR_GROUP, function (_ref26) {
  var group = _ref26.group;
  return {
    group: group
  };
});
var publicGetQueueForm = createActionCreator(PUBLIC_GET_QUEUE_FORM, function (_ref27) {
  var promise = _ref27.promise;
  return {
    promise: promise
  };
});

var prefix = '';
var storage = testStorageSupport() ? window.localStorage : memoryStorage;
var setItem = function setItem(name, value) {
  storage.setItem(prefix + name, value);
};
var getItem = function getItem(name) {
  return storage.getItem(prefix + name);
};
var removeItem = function removeItem(name) {
  storage.removeItem(prefix + name);
};
var setPrefix = function setPrefix(newPrefix) {
  prefix = newPrefix;
};
var removeOldSecretTokenCookie = function removeOldSecretTokenCookie(license) {
  document.cookie = "secret_token_" + license + ("=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/licence/" + license + "/v2;domain=.livechatinc.com");
  document.cookie = "secret_token_" + license + ("=; expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/licence/" + license + ";domain=.livechatinc.com");
};
var storage$1 = {
  setItem: setItem,
  getItem: getItem,
  removeItem: removeItem,
  setPrefix: setPrefix,
  removeOldSecretTokenCookie: removeOldSecretTokenCookie
};

function parseUrlToCdn(path) {
  if (path.indexOf('cdn.livechatinc.com/cloud/?uri') !== -1) {
    return 'https://' + removeProtocol(path);
  }

  return 'https://cdn.livechatinc.com/cloud/?uri=http://' + encodeURI(removeProtocol(path));
}

function parseInvitation(invitationObject) {
  var agent = invitationObject.agent;
  return {
    invitation: {
      id: invitationObject.unique_id,
      authorId: agent.login,
      text: invitationObject.greeting_message.text,
      receivedFirstTime: invitationObject.displayed_first_time
    },
    agent: {
      avatarUrl: parseUrlToCdn(agent.avatar_url),
      jobTitle: agent.job_title,
      name: agent.name,
      id: agent.login
    }
  };
}

var sortFieldOrder = function sortFieldOrder(fieldA, fieldB) {
  return fieldA.order - fieldB.order;
};

var typeMap = {
  question: {
    type: 'text'
  },
  checkbox_for_email: {
    type: 'checkbox',
    meta: 'confirm_subscription'
  },
  header: {
    type: 'information'
  },
  skill: {
    type: 'group_select'
  }
};

var parseType = function parseType(type) {
  return {
    type: typeMap[type] && typeMap[type].type || type,
    meta: typeMap[type] && typeMap[type].meta || false
  };
};

var parseAnswerType = function parseAnswerType(answerType, meta) {
  if (meta === void 0) {
    meta = false;
  }

  return findKey(function (_ref) {
    var fieldType = _ref.type,
        fieldMeta = _ref.meta;
    return fieldType === answerType && (!fieldMeta || meta === fieldMeta);
  }, typeMap) || answerType;
};

var parseOptions = function parseOptions(options) {
  return options.map(function (option, index) {
    var parsedOption = {};

    if (hasOwn('label', option)) {
      parsedOption.label = option.label;
    }

    if (hasOwn('checked', option)) {
      parsedOption.checked = option.checked;
    }

    parsedOption.value = String(index);

    if (hasOwn('skill_id', option)) {
      parsedOption.value = String(option.skill_id);
    }

    if (hasOwn('embedded_chat_hide_when_offline', option)) {
      parsedOption.ticketFormDisabled = Boolean(option.embedded_chat_hide_when_offline);
    }

    if (hasOwn('queue_template', option)) {
      parsedOption.queueTemplate = option.queue_template;
    }

    return parsedOption;
  });
};

var translateForm = function translateForm(incomingForm) {
  var formWithFacebookConnect = false;
  var parsed = {
    fields: incomingForm.fields.sort(sortFieldOrder).map(function (field, index) {
      var parsedField = {};

      if (field.type === 'facebookConnect') {
        formWithFacebookConnect = true;
        return false;
      }

      if (field.id) {
        parsedField.name = field.id;
      } else if (['header', 'information'].indexOf(field.type) === -1) {
        parsedField.name = String(index);
      }

      if (hasOwn('value', field)) {
        parsedField.value = field.value;
      }

      if (hasOwn('label', field)) {
        parsedField.label = field.label;
      }

      if (hasOwn('required', field)) {
        parsedField.required = field.required;
      }

      if (field.type === 'rating') {
        parsedField.commentLabel = field.options[0];
      }

      if (field.skills && field.skills.length > 0) {
        parsedField.options = parseOptions(field.skills);
      } else if (field.options && field.options.length > 0) {
        if (field.options_data) {
          parsedField.options = parseOptions(field.options_data); // this if statement is to support new protocol
        } else if (isObject(field.options[0])) {
          parsedField.options = field.options.map(function (_ref2, optionIndex) {
            var label = _ref2.label;
            return {
              label: label,
              value: String(optionIndex)
            };
          });
        } else {
          parsedField.options = field.options.map(function (option, optionIndex) {
            return {
              label: option,
              value: String(optionIndex)
            };
          });
        }
      }

      if (field.serverType) {
        parsedField.serverType = field.serverType;
      }

      var _parseType = parseType(field.type),
          type = _parseType.type,
          meta = _parseType.meta;

      parsedField.type = type;

      if (meta) {
        parsedField.meta = meta;
      }

      return parsedField;
    }).filter(Boolean)
  };

  if (incomingForm.id) {
    parsed.id = incomingForm.id;
  }

  if (formWithFacebookConnect) {
    parsed.facebookConnect = true;
  }

  return parsed;
};
var ensureTicketFormRequiredFields = function ensureTicketFormRequiredFields(form) {
  return _extends({}, form, {
    fields: form.fields.map(function (field) {
      if (field.type === 'email' || field.type === 'textarea') {
        return _extends({}, field, {
          required: true
        });
      }

      return field;
    })
  });
};
var translateFormAnswers = function translateFormAnswers(incomingAnswers, form, choosenGroupIndex) {
  var parsed = {
    survey_id: form.id
  };
  var answerableTypes = ['name', 'question', 'email', 'checkbox', 'checkbox_for_email', 'radio', 'skill', 'select', 'textarea'];
  var parsedFields = form.fields.map(function (field, index) {
    var parsedField = {
      id: field.name,
      order: form.facebookConnect ? index + 1 : index,
      type: parseAnswerType(field.type, field.meta)
    };

    if (hasOwn('label', field)) {
      parsedField.label = field.label;
    }

    if (hasOwn('options', field)) {
      parsedField.answers = field.options.map(function (option, optionIndex) {
        var parsedOption = {
          index: optionIndex
        };

        if (hasOwn('label', option)) {
          parsedOption.label = option.label;
        }

        if (parsedField.type === 'skill') {
          parsedOption.group_id = parseInt(option.value, 10);
        }

        if (field.type === 'group_select') {
          parsedOption.chosen = parseInt(choosenGroupIndex, 10) === optionIndex;
        } else {
          parsedOption.chosen = incomingAnswers[field.name] && (Array.isArray(incomingAnswers[field.name]) && incomingAnswers[field.name].indexOf(option.value) !== -1 || typeof incomingAnswers[field.name] === 'string' && incomingAnswers[field.name] === option.value) || false;
        }

        return parsedOption;
      });
    } else {
      parsedField.answer = incomingAnswers[field.name] || '';
    }

    return parsedField;
  }).filter(function (field) {
    return answerableTypes.indexOf(field.type) !== -1;
  });
  parsed.fields = parsedFields;
  return parsed;
};

var PRODUCTION = 'production';
var STAGING = 'staging';
var LABS = 'labs';

var _serverEnvPart, _apiEnvPart;
var serverEnvPart = (_serverEnvPart = {}, _serverEnvPart[LABS] = '-labs.', _serverEnvPart[STAGING] = '-lc.', _serverEnvPart[PRODUCTION] = '.', _serverEnvPart);
var apiEnvPart = (_apiEnvPart = {}, _apiEnvPart[LABS] = 'labs.', _apiEnvPart[STAGING] = 'staging.', _apiEnvPart[PRODUCTION] = '', _apiEnvPart);

var delay$1 = function delay$$1(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

var getServerUrl = function getServerUrl(region, environment, license) {
  var parsedEnvironment = environment;

  if (license === 1520) {
    parsedEnvironment = STAGING;
  }

  return "https://secure" + (region ? '-' + region : '') + serverEnvPart[parsedEnvironment] + "livechatinc.com";
};

var getAPIUrl = function getAPIUrl(region, environment, license) {
  var parsedEnvironment = environment;

  if (license === 1520) {
    parsedEnvironment = STAGING;
  }

  return "https://api" + (region ? '-' + region : '') + "." + apiEnvPart[parsedEnvironment] + "livechatinc.com";
};

var generateRandomId = function generateRandomId(size) {
  var randomId = '';
  var chars = '0123456789abcdefghijklmnopqurstuvwxyzABCDEFGHIJKLMNOPQURSTUVWXYZ';

  for (var counter = 0; counter < size; counter++) {
    randomId += chars.substr(Math.floor(Math.random() * chars.length), 1);
  }

  return randomId;
};

var fetchWithRetry = function fetchWithRetry(url, body, options) {
  if (options === void 0) {
    options = {};
  }

  var attempts = options.attempts || 3;
  var retryDelay = options.retryDelay || 1000;
  return new Promise(function (resolve, reject) {
    var fetchRequest = function fetchRequest() {
      fetch(url, body).then(function (response) {
        if (response.status === 400) {
          response.json().then(reject).catch(reject);
          return;
        }

        if (response.ok) {
          resolve(response);
          return;
        }

        throw new Error({
          type: 'connection',
          reason: 'Request failed'
        });
      }).catch(function (error) {
        if (attempts) {
          --attempts;
          return setTimeout(function () {
            fetchRequest();
          }, retryDelay);
        }

        return reject(error);
      });
      delay$1(15 * 1000).then(function () {
        reject({
          type: 'connection',
          reason: 'Request timeout'
        });
      });
    };

    fetchRequest();
  });
};

var sendFileToAPI = function sendFileToAPI(_ref) {
  var environment = _ref.environment,
      region = _ref.region,
      license = _ref.license,
      token = _ref.token,
      file = _ref.file,
      chatId = _ref.chatId,
      onProgress = _ref.onProgress;
  var requestUrl = getAPIUrl(region, environment, license) + "/v2/chats/" + chatId + "/attachment";
  var promise = fileUpload(requestUrl, {
    'author[type]': 'visitor',
    license_id: license,
    files: file,
    token: token
  }, {
    onProgress: onProgress
  });
  promise[CANCEL] = promise.cancel;
  return promise;
}; // remove those ASCII range 1-8, 11-12, 14-31, 127
// eslint-disable-next-line no-control-regex

var stripIncorrectJSONCharacters = function stripIncorrectJSONCharacters(str) {
  return str.replace(/[\x01-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
};

var sendPostToAPI = function sendPostToAPI(methodName, _ref2, options) {
  var environment = _ref2.environment,
      region = _ref2.region,
      license = _ref2.license,
      body = _ref2.body;
  var requestUrl = getAPIUrl(region, environment, license) + "/" + methodName;
  return fetchWithRetry(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(body)
  }, options).then(function (response) {
    return response.json();
  });
};
var fetchWebservResource = function fetchWebservResource(url, _ref3) {
  var environment = _ref3.environment,
      license = _ref3.license,
      region = _ref3.region;
  var requestUrl = "" + getServerUrl(region, environment, license) + url;
  return fetchWithRetry(requestUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then(function (response) {
    return response.json();
  });
};

var getLicensePart = function getLicensePart(license, chatBetweenGroups, external, group) {
  if (chatBetweenGroups === false) {
    return "licence/g" + license + "_" + group;
  }

  if (external) {
    return "licence/external/" + license;
  }

  return "licence/" + license;
};

var sendPostToWebserv = function sendPostToWebserv(methodName, _ref4, options) {
  var environment = _ref4.environment,
      license = _ref4.license,
      _ref4$body = _ref4.body,
      body = _ref4$body === void 0 ? {} : _ref4$body,
      securedToken = _ref4.securedToken,
      secretId = _ref4.secretId,
      region = _ref4.region,
      _ref4$queryStringData = _ref4.queryStringData,
      queryStringData = _ref4$queryStringData === void 0 ? {} : _ref4$queryStringData,
      external = _ref4.external,
      chatBetweenGroups = _ref4.chatBetweenGroups,
      group = _ref4.group,
      requestDistribution = _ref4.requestDistribution;
  var webservPart = get(methodName, requestDistribution) === true || methodName.indexOf('get_static_config') !== -1 ? 'v2/' : '';
  var queryStringObject = {};

  if (securedToken) {
    queryStringObject.secret_token = securedToken;
  }

  if (secretId) {
    queryStringObject.secret_id = secretId;
  }

  var requestUrl = getServerUrl(region, environment, license) + "/" + getLicensePart(license, chatBetweenGroups, external, group) + "/" + webservPart + methodName + "?" + buildQueryString(_extends({}, queryStringData, queryStringObject));
  return fetchWithRetry(requestUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: JSON.stringify(body)
  }, options).then(function (response) {
    return response.text();
  }).then(function (response) {
    return JSON.parse(stripIncorrectJSONCharacters(response));
  });
};
var sendIWCS = function sendIWCS(command, _ref5) {
  var environment = _ref5.environment,
      license = _ref5.license,
      securedToken = _ref5.securedToken,
      secretId = _ref5.secretId,
      region = _ref5.region,
      external = _ref5.external,
      group = _ref5.group,
      chatBetweenGroups = _ref5.chatBetweenGroups;
  var requestUrl = getServerUrl(region, environment, license) + "/" + getLicensePart(license, chatBetweenGroups, external, group) + "/tunnel_callback.cgi?" + generateRandomId(20);

  if (securedToken) {
    requestUrl += "&secret_token=" + securedToken;
  }

  if (secretId) {
    requestUrl += "&secret_id=" + secretId;
  }

  requestUrl += "&command=" + encodeURIComponent(command);
  return fetchWithRetry(requestUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include'
  }).then(function (response) {
    return response.text();
  }).then(function (responseText) {
    return responseText.split('^');
  });
};

var _marked =
/*#__PURE__*/
_regeneratorRuntime.mark(getDynamicConfig),
    _marked2 =
/*#__PURE__*/
_regeneratorRuntime.mark(dynamicConfig);

function getDynamicConfig(requestData, queryStringData) {
  var chatBetweenGroups, group, requestUrl, response, newResponse, _newResponse;

  return _regeneratorRuntime.wrap(function getDynamicConfig$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyChatBetweenGroups);

        case 2:
          chatBetweenGroups = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyGroup);

        case 5:
          group = _context.sent;
          requestUrl = 'get_dynamic_config.js';
          _context.t0 = call;
          _context.t1 = sendPostToWebserv;
          _context.t2 = requestUrl;
          _context.t3 = _extends;
          _context.t4 = {};
          _context.t5 = requestData;
          _context.t6 = queryStringData;
          _context.next = 16;
          return getContext('external');

        case 16:
          _context.t7 = _context.sent;
          _context.t8 = {
            queryStringData: _context.t6,
            external: _context.t7
          };
          _context.t9 = (0, _context.t3)(_context.t4, _context.t5, _context.t8);
          _context.next = 21;
          return (0, _context.t0)(_context.t1, _context.t2, _context.t9);

        case 21:
          response = _context.sent;

          if (!(response.error && response.error === 'incorrect region')) {
            _context.next = 40;
            break;
          }

          _context.next = 25;
          return put(propsActions.setPropertyRegion(response.region));

        case 25:
          _context.t10 = call;
          _context.t11 = getDynamicConfig;
          _context.t12 = _extends;
          _context.t13 = {};
          _context.t14 = requestData;
          _context.t15 = response.region;
          _context.next = 33;
          return getContext('external');

        case 33:
          _context.t16 = _context.sent;
          _context.t17 = {
            region: _context.t15,
            external: _context.t16
          };
          _context.t18 = (0, _context.t12)(_context.t13, _context.t14, _context.t17);
          _context.next = 38;
          return (0, _context.t10)(_context.t11, _context.t18);

        case 38:
          newResponse = _context.sent;
          return _context.abrupt("return", newResponse);

        case 40:
          if (!(chatBetweenGroups === false && response.visitor.groups !== group)) {
            _context.next = 57;
            break;
          }

          _context.next = 43;
          return put(propsActions.setPropertyGroup(response.visitor.groups));

        case 43:
          _context.t19 = call;
          _context.t20 = getDynamicConfig;
          _context.t21 = _extends;
          _context.t22 = {};
          _context.t23 = requestData;
          _context.next = 50;
          return getContext('external');

        case 50:
          _context.t24 = _context.sent;
          _context.t25 = {
            external: _context.t24
          };
          _context.t26 = (0, _context.t21)(_context.t22, _context.t23, _context.t25);
          _context.next = 55;
          return (0, _context.t19)(_context.t20, _context.t26);

        case 55:
          _newResponse = _context.sent;
          return _context.abrupt("return", _newResponse);

        case 57:
          return _context.abrupt("return", response);

        case 58:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}

function dynamicConfig() {
  var license, group, environment, region, visitorData, chatBetweenGroups, queryStringData;
  return _regeneratorRuntime.wrap(function dynamicConfig$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(propsSelectors.getPropertyLicense);

        case 2:
          license = _context2.sent;
          _context2.next = 5;
          return select(propsSelectors.getPropertyGroup);

        case 5:
          group = _context2.sent;
          _context2.next = 8;
          return select(getEnvironment);

        case 8:
          environment = _context2.sent;
          _context2.next = 11;
          return select(propsSelectors.getPropertyRegion);

        case 11:
          region = _context2.sent;
          _context2.next = 14;
          return select(getVisitorData);

        case 14:
          visitorData = _context2.sent;
          _context2.next = 17;
          return select(propsSelectors.getPropertyChatBetweenGroups);

        case 17:
          chatBetweenGroups = _context2.sent;
          queryStringData = {};

          if (visitorData.pageUrl) {
            queryStringData.url = visitorData.pageUrl;
          }

          if (typeof group !== 'undefined') {
            queryStringData.groups = group;
          }

          _context2.next = 23;
          return call(getDynamicConfig, {
            environment: environment,
            license: license,
            group: group,
            region: region,
            chatBetweenGroups: chatBetweenGroups
          }, queryStringData);

        case 23:
          return _context2.abrupt("return", _context2.sent);

        case 24:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

var GOOD = 'good';
var BAD = 'bad';
var NONE = 'none';

var _rateMap;
/**
 * Function removes those ASCII characters ranges:
 * 1-8, 11-12, 14-31, 127
 */

var stripIncorrectCharacters = function stripIncorrectCharacters(text) {
  // eslint-disable-next-line no-control-regex
  return text.replace(/[\x01-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '');
};

var codeToBoolean = function codeToBoolean(code) {
  if (code === '1') {
    return true;
  }

  return false;
};

var encodeIwcsChars = function encodeIwcsChars(text) {
  return text.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&#94;/g, '^').replace(/&#45;/g, '-').replace(/&amp;/g, '&').replace(/<BR>/g, '\n');
};

var parseAgentMessage = encodeIwcsChars;
var parseJson = function parseJson(text) {
  return JSON.parse(encodeIwcsChars(text));
};

var parseCustomJson = function parseCustomJson(data) {
  if (!data) {
    return null;
  }

  try {
    var parsed = parseJson(data);
    return parsed;
  } catch (error) {
    return null;
  }
}; // currently this IWCS is used only with PostChat (code 1)


var formTypeToCode = function formTypeToCode() {
  return '1';
};

var rateMap = (_rateMap = {}, _rateMap[NONE] = '0', _rateMap[BAD] = '1', _rateMap[GOOD] = '2', _rateMap);

var parseSubIWCS = function parseSubIWCS(subIWCS) {
  var params = subIWCS.split('&#45;');
  return {
    authorId: params[1],
    isTyping: codeToBoolean(params[2])
  };
}; // const rateToCode = (rate: $Values<typeof rates>) => rateMap[rate]


var rateToCode = function rateToCode(rate) {
  return rateMap[rate];
};

var codeToRate = function codeToRate(code) {
  return find(function (rate) {
    return rateMap[rate] === code;
  }, Object.keys(rateMap));
};

var IWCSMessageNames = {
  NEW_AGENT: 'newAgent',
  NEW_AGENT_MESSAGE: 'newAgentMessage',
  CHAT_ENDED: 'chatEnded',
  VISITOR_QUEUED: 'visitorQueued',
  TYPING_INDICATOR: 'typingIndicator',
  RATE_CHAT: 'rateChat',
  FORWARD_CHAT_TRANSCRIPT: 'forwardChatTranscript',
  AGENTS_OFFLINE: 'agentsOffline',
  GET_FORM: 'getForm',
  GET_CUSTOM_FORM: 'getCustomForm',
  JSON: 'JSON',
  INTEGRATION_DATA: 'integrationData' // const parseAgentIds = (agentsIds: string) => agentsIds.replace(/\;$/, '').split(';')

};
var IWCSDictionary = {
  IWCS5012F: [IWCSMessageNames.AGENTS_OFFLINE, {}],
  IWCS5011F: [IWCSMessageNames.AGENTS_OFFLINE, {}],
  IWCS0002R: [IWCSMessageNames.NEW_AGENT, {
    '1': ['id'],
    '2': ['name', encodeIwcsChars],
    // '4': ['chatId'], // WTF?!
    '12': ['chatId'],
    // old conference_id
    // '16': ['operators_id', parseAgentIds],
    '23': ['avatarUrl', encodeIwcsChars],
    '25': ['jobTitle', encodeIwcsChars]
  }],
  IWCS0006R: [IWCSMessageNames.NEW_AGENT_MESSAGE, {
    '1': ['authorId'],
    '2': ['message', parseAgentMessage],
    '9': ['isMobile', codeToBoolean],
    '10': ['id'],
    '11': ['json', parseCustomJson]
  }],
  IWCS1007S: [IWCSMessageNames.CHAT_ENDED, null, {
    reason: 'closed'
  }],
  IWCS0093R: [IWCSMessageNames.CHAT_ENDED, null, {
    reason: 'inactivity'
  }],
  IWCS0003R: [IWCSMessageNames.CHAT_ENDED, null, {
    reason: 'closed_by_agent'
  }],
  IWCS1002S: [IWCSMessageNames.VISITOR_QUEUED, {
    '2': ['numberInQueue', parseInt],
    '3': ['waitingTime', parseInt]
  }],
  IWCS0002P: [IWCSMessageNames.TYPING_INDICATOR, {
    '2': ['realCommand', parseSubIWCS]
  }],
  IWCS0113C: [IWCSMessageNames.RATE_CHAT, {
    '1': ['visitorId'],
    '2': ['chatId'],
    '3': ['rate', codeToRate, rateToCode]
  }],
  IWCS0069C: [IWCSMessageNames.FORWARD_CHAT_TRANSCRIPT, {
    '1': ['visitorId'],
    '2': ['email'],
    '5': ['chatId']
  }],
  IWCS0121C: [IWCSMessageNames.GET_FORM, {
    '1': ['type', null, formTypeToCode],
    '2': ['license'],
    '4': ['group']
  }],
  IWCS0122C: [IWCSMessageNames.GET_CUSTOM_FORM, {
    '1': ['license'],
    '2': ['type'],
    '3': ['group']
  }],
  IWCSJSON: [IWCSMessageNames.JSON, {
    '1': ['json', parseJson]
  }],
  IWCS0109R: [IWCSMessageNames.INTEGRATION_DATA, {
    '1': ['integrationName'],
    '2': ['data', parseJson]
  }]
};
var translateIWCS = function translateIWCS(IWCSMessage) {
  var splittedMessage = IWCSMessage.split('^');
  var commandCode = splittedMessage[0],
      data = splittedMessage.slice(1);
  var command = IWCSDictionary[commandCode];

  if (!command) {
    return null;
  }

  var commandName = command[0],
      paramsMap = command[1],
      _command$ = command[2],
      additionalData = _command$ === void 0 ? {} : _command$;
  var parsedData = data.reduce(function (parsed, param, index) {
    if (!paramsMap || !paramsMap[index + 1]) {
      return parsed;
    }

    var _paramsMap = paramsMap[index + 1],
        paramName = _paramsMap[0],
        _paramsMap$ = _paramsMap[1],
        parseFunction = _paramsMap$ === void 0 ? identity : _paramsMap$;

    if (paramName === 'realCommand') {
      return _extends({}, parsed, parseFunction(param));
    }

    parsed[paramName] = parseFunction(param);
    return parsed;
  }, {});
  return {
    name: commandName,
    data: _extends({}, parsedData, additionalData)
  };
};
var translateToIWCS = function translateToIWCS(methodName, data) {
  var IWCSCommandCode = findKey(function (iwcs) {
    return iwcs[0] === methodName;
  }, IWCSDictionary);
  var IWCSShapeDeclaration = IWCSDictionary[IWCSCommandCode][1];
  var maxParam = Math.max.apply(Math, Object.keys(IWCSShapeDeclaration));
  var translatedIWCS = [IWCSCommandCode];

  while (translatedIWCS.length < maxParam + 1) {
    var paramData = IWCSShapeDeclaration[translatedIWCS.length];

    if (!paramData) {
      translatedIWCS.push('');
      continue;
    }

    var paramName = paramData[0];
    var parsedData = stripIncorrectCharacters(String(data[paramName])).replace(/\^/g, '&#94;');

    if (paramData[2]) {
      translatedIWCS.push(paramData[2](parsedData));
      continue;
    }

    translatedIWCS.push(parsedData);
  }

  return translatedIWCS.join('^') + '^';
};

var _marked$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(getRequestMeta),
    _marked2$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendJsonRequest),
    _marked3 =
/*#__PURE__*/
_regeneratorRuntime.mark(getWebservResource),
    _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendIWCSRequest),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendApiRequest);

function getRequestMeta() {
  var metadaData;
  return _regeneratorRuntime.wrap(function getRequestMeta$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return all({
            license: select(propsSelectors.getPropertyLicense),
            securedToken: select(propsSelectors.getPropertySecuredToken),
            secretId: select(propsSelectors.getPropertySecretId),
            environment: select(getEnvironment),
            region: select(propsSelectors.getPropertyRegion),
            external: getContext('external'),
            group: select(propsSelectors.getPropertyGroup),
            chatBetweenGroups: select(propsSelectors.getPropertyChatBetweenGroups),
            requestDistribution: select(propsSelectors.getPropertyRequestDistribution)
          });

        case 2:
          metadaData = _context.sent;
          return _context.abrupt("return", metadaData);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$1);
}

function sendJsonRequest(methodName, body, options) {
  var requestMeta;
  return _regeneratorRuntime.wrap(function sendJsonRequest$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (options === void 0) {
            options = {};
          }

          _context2.next = 3;
          return call(getRequestMeta);

        case 3:
          requestMeta = _context2.sent;
          _context2.next = 6;
          return call(sendPostToWebserv, methodName, _extends({}, requestMeta, {
            body: body
          }), options);

        case 6:
          return _context2.abrupt("return", _context2.sent);

        case 7:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$1);
}
function getWebservResource(url) {
  var requestMeta, response;
  return _regeneratorRuntime.wrap(function getWebservResource$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(getRequestMeta);

        case 2:
          requestMeta = _context3.sent;
          _context3.next = 5;
          return call(fetchWebservResource, url, requestMeta);

        case 5:
          response = _context3.sent;
          return _context3.abrupt("return", response);

        case 7:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}
function sendIWCSRequest(methodName, body) {
  var translatedIWCS, requestMeta;
  return _regeneratorRuntime.wrap(function sendIWCSRequest$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          translatedIWCS = translateToIWCS(methodName, body);
          _context4.next = 3;
          return call(getRequestMeta);

        case 3:
          requestMeta = _context4.sent;
          _context4.next = 6;
          return call(sendIWCS, translatedIWCS, requestMeta);

        case 6:
          return _context4.abrupt("return", _context4.sent);

        case 7:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
function sendApiRequest(methodName, body) {
  var requestMeta, license, environment, region;
  return _regeneratorRuntime.wrap(function sendApiRequest$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(getRequestMeta);

        case 2:
          requestMeta = _context5.sent;
          license = requestMeta.license, environment = requestMeta.environment, region = requestMeta.region;
          _context5.next = 6;
          return call(sendPostToAPI, methodName, {
            environment: environment,
            region: region,
            license: license,
            body: body
          });

        case 6:
          return _context5.abrupt("return", _context5.sent);

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}

var _marked$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(staticConfig);
function staticConfig(group, version) {
  var requestBody;
  return _regeneratorRuntime.wrap(function staticConfig$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          requestBody = {};
          _context.next = 3;
          return call(sendJsonRequest, "get_static_config." + group + "." + version + ".js", requestBody);

        case 3:
          return _context.abrupt("return", _context.sent);

        case 4:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$2);
}

var _marked$3 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleStaticConfigResponse),
    _marked2$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleServerConfig),
    _marked3$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchStaticConfig),
    _marked4$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchTranslations),
    _marked5$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(setInitialVisitorData),
    _marked6 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleDynamicConfigResponse),
    _marked7 =
/*#__PURE__*/
_regeneratorRuntime.mark(checkProtocolVersion),
    _marked8 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee);

var parseGroups = function parseGroups(groups, onlineGroups) {
  return keyBy('id', groups.map(function (group) {
    return {
      id: group.id,
      status: onlineGroups.indexOf(group.id) !== -1 ? 'online' : 'offline',
      oldButtons: {
        onlineImage: parseUrlToCdn(group.chat_button.online_url),
        offlineImage: parseUrlToCdn(group.chat_button.offline_url)
      }
    };
  }));
};

var parseCuromJson = function parseCuromJson(customJson) {
  var parsedJson = {};

  try {
    parsedJson = JSON.parse(customJson); // eslint-disable-next-line no-empty
  } catch (error) {}

  return parsedJson;
};

var parseServerConfig = function parseServerConfig(serverConfig) {
  var licenseProperties = serverConfig.license_properties,
      groupProperties = serverConfig.group_properties;
  var mobileOverrided = groupProperties.chat_window.custom_mobile_settings === '1';
  var nonProfitLicense = licenseProperties.non_profit === '1';
  var isLC3 = licenseProperties.lc_version === '3';
  var isContinuousChatEnabled = isLC3 && licenseProperties.continuous_chat_widget_enabled === '1';
  var parsed = {
    nonProfitLicense: nonProfitLicense,
    visitorData: mapKeys(camelCase, serverConfig.visitor),
    features: {
      fileSharing: {
        enabled: serverConfig.attachments.enable_for_visitors
      },
      agentAvatar: {
        enabled: serverConfig.chat_window.display_avatar,
        showWithMessage: serverConfig.chat_window.display_avatar && get('group_properties.chat_window.new_theme.name', serverConfig) !== 'modern'
      },
      continuousChat: {
        enabled: isContinuousChatEnabled
      },
      chatHistory: {
        enabled: isContinuousChatEnabled || isLC3 && licenseProperties.customer_history_enabled === '1'
      },
      rating: {
        enabled: serverConfig.chat_window.display_rating,
        position: get('group_properties.chat_window.new_theme.name', serverConfig) === 'modern' ? 'bottom' : 'right'
      },
      emailTranscript: {
        enabled: serverConfig.chat_window.display_transcript_button
      },
      logo: {
        enabled: serverConfig.chat_window.logo.display,
        path: parseUrlToCdn(serverConfig.chat_window.logo.path)
      },
      facebookButton: {
        enabled: Boolean(serverConfig.chat_window.social.facebook)
      },
      twitterButton: {
        enabled: Boolean(serverConfig.chat_window.social.twitter)
      },
      googlePlusButton: {
        enabled: Boolean(serverConfig.chat_window.social.plusone)
      },
      offlineForm: {
        enabled: !serverConfig.embedded_chat.hide_when_offline
      },
      linksPreview: {
        enabled: groupProperties.links_unfurling === '1'
      },
      preChatForm: {
        enabled: serverConfig.pre_chat_survey && serverConfig.pre_chat_survey.enabled || false
      },
      preChatAfterGreeting: {
        enabled: groupProperties.pre_chat_survey_after_greeting === '1'
      },
      creditCardMasking: {
        enabled: serverConfig.mask_credit_cards
      },
      hideTrademark: {
        enabled: groupProperties.chat_window.hide_trademark === '1'
      },
      hideOnMobile: {
        enabled: groupProperties.chat_window.hide_on_mobile === '1'
      },
      hideOnInit: {
        enabled: groupProperties.chat_window.hide_on_init === '1'
      },
      disableSounds: {
        enabled: groupProperties.chat_window.disable_sounds === '1'
      },
      minimized: {
        enabled: groupProperties.chat_window.disable_minimized === '0'
      },
      mobileMinimized: {
        enabled: mobileOverrided ? groupProperties.chat_window.mobile_disable_minimized === '0' : groupProperties.chat_window.disable_minimized === '0'
      }
    },
    buttons: serverConfig.buttons.map(function (button) {
      return {
        id: button.id,
        type: button.type,
        onlineImage: parseUrlToCdn(button.online_value),
        offlineImage: parseUrlToCdn(button.offline_value)
      };
    }),
    theme: {
      color: serverConfig.chat_window.theme.color,
      name: serverConfig.chat_window.theme.name,
      minimized: groupProperties.chat_window.theme.minimized,
      mobileMinimized: mobileOverrided ? groupProperties.chat_window.mobile_minimized_theme : groupProperties.chat_window.theme.minimized
    },
    newTheme: {
      name: groupProperties.chat_window.new_theme.name,
      iconTheme: groupProperties.chat_window.new_theme.name === 'modern' ? 'modern' : 'smooth',
      agentMessageBackgroundColor: getOr('#fffff', 'group_properties.chat_window.new_theme.agent_message_color_background', serverConfig),
      agentMessageColorText: getOr('#424d57', 'group_properties.chat_window.new_theme.agent_message_color_text', serverConfig),
      backgroundColor: getOr('#e9eef4', 'group_properties.chat_window.new_theme.background_color', serverConfig).toLowerCase(),
      minimizedColorBackground: getOr('#ffffff', 'group_properties.chat_window.new_theme.minimized_color_background', serverConfig),
      minimizedColorIcon: getOr('#4384F5', 'group_properties.chat_window.new_theme.minimized_color_icon', serverConfig),
      minimizedColorText: getOr('#000000', 'group_properties.chat_window.new_theme.minimized_color_text', serverConfig),
      visitorMessageBackgroundColor: getOr('#4384f5', 'group_properties.chat_window.new_theme.visitor_message_color_background', serverConfig),
      visitorMessageColorText: getOr('#ffffff', 'group_properties.chat_window.new_theme.visitor_message_color_text', serverConfig),
      titlebarBackgroundColor: getOr('#ffffff', 'group_properties.chat_window.new_theme.titlebar_background_color', serverConfig),
      titlebarText: getOr('#424d57', 'group_properties.chat_window.new_theme.titlebar_text', serverConfig),
      systemMessageColor: getOr('#424d57', 'group_properties.chat_window.new_theme.system_message_color', serverConfig),
      agentbarBackgroundColor: getOr('#ffffff', 'group_properties.chat_window.new_theme.agentbar_background_color', serverConfig),
      agentbarText: getOr('#424d57', 'group_properties.chat_window.new_theme.agentbar_text', serverConfig),
      ctaColor: getOr('#427fe1', 'group_properties.chat_window.new_theme.cta_color', serverConfig),
      customJson: parseCuromJson(get('group_properties.chat_window.new_theme.custom_json', serverConfig))
    },
    domainWhitelist: serverConfig.domain_whitelist,
    widgetType: serverConfig.embedded_chat.enabled ? 'embedded' : 'popup',
    integrations: serverConfig.integrations,
    language: serverConfig.lang,
    groups: parseGroups(serverConfig.skills, serverConfig.skills_online),
    clientLimitExceeded: serverConfig.client_limit_exceeded,
    screenPosition: groupProperties.chat_window.screen_position,
    mobileScreenPosition: mobileOverrided ? groupProperties.chat_window.mobile_screen_position : groupProperties.chat_window.screen_position
  };

  if (parsed.features.facebookButton.enabled) {
    parsed.features.facebookButton.path = serverConfig.chat_window.social.facebook;
  }

  if (parsed.features.twitterButton.enabled) {
    parsed.features.facebookButton.path = serverConfig.chat_window.social.twitter;
  }

  if (parsed.features.googlePlusButton.enabled) {
    parsed.features.facebookButton.path = serverConfig.chat_window.social.plusone;
  }

  return parsed;
};

function handleStaticConfigResponse(response) {
  var external, translatedPrechatForm, localizationUrl;
  return _regeneratorRuntime.wrap(function handleStaticConfigResponse$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return put(propsActions.setPropertyTicketForm(ensureTicketFormRequiredFields(translateForm(response.offline_form))));

        case 2:
          _context.next = 4;
          return getContext('external');

        case 4:
          external = _context.sent;

          if (!response.pre_chat_survey) {
            _context.next = 9;
            break;
          }

          translatedPrechatForm = translateForm(response.pre_chat_survey);
          _context.next = 9;
          return put(propsActions.setPropertyPreChatForm(translatedPrechatForm));

        case 9:
          localizationUrl = external ? response.localization_url.replace('/licence/', '/licence/external/') : response.localization_url;
          _context.next = 12;
          return put(propsActions.setPropertyTranslationsVersion(localizationUrl));

        case 12:
          _context.next = 14;
          return put(propsActions.setPropertyConfigLoaded(true));

        case 14:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$3);
}

var globalPropertiesEnvMap = {
  labs: 'labs',
  staging: 'staging',
  production: 'prod'
};

var parseRequestDistribution = function parseRequestDistribution(turnOff, requestsDistributionString) {
  var pairs = requestsDistributionString.split(',').map(function (current) {
    return current.split(':');
  });
  var distributions = fromPairs(pairs);
  return mapValues(function (value) {
    if (!value) {
      return false;
    }

    var ratio = parseFloat(value);

    if (ratio < 1 && turnOff) {
      return false;
    }

    if (ratio > Math.random()) {
      return true;
    }

    return false;
  }, distributions);
};

function handleServerConfig(serverConfig) {
  var environment, envProperty, requestDistributionString, turnOff, parsedRequestDistribution, parsedConfig, group;
  return _regeneratorRuntime.wrap(function handleServerConfig$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(getEnvironment);

        case 2:
          environment = _context2.sent;
          envProperty = globalPropertiesEnvMap[environment];
          requestDistributionString = serverConfig.global_properties[envProperty].requests_distribution;
          turnOff = serverConfig.t === false;
          parsedRequestDistribution = parseRequestDistribution(turnOff, requestDistributionString);
          _context2.next = 9;
          return put(propsActions.setPropertyRequestDistribution(parsedRequestDistribution));

        case 9:
          parsedConfig = parseServerConfig(serverConfig);
          _context2.next = 12;
          return select(propsSelectors.getPropertyGroup);

        case 12:
          group = _context2.sent;

          if (!(serverConfig.skills_online.indexOf(group) !== -1)) {
            _context2.next = 18;
            break;
          }

          _context2.next = 16;
          return put(propsActions.setPropertyChatStatus('ONLINE'));

        case 16:
          _context2.next = 20;
          break;

        case 18:
          _context2.next = 20;
          return put(propsActions.setPropertyChatStatus('OFFLINE'));

        case 20:
          _context2.next = 22;
          return put(propsActions.setPropertyConfig(parsedConfig));

        case 22:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$2);
}

function fetchStaticConfig() {
  var staticConfigVersion, group, staticConfigResponse, dynamicConfigResponse, serverConfig;
  return _regeneratorRuntime.wrap(function fetchStaticConfig$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return call(waitForState, propsSelectors.getPropertyStaticConfigVersion);

        case 2:
          staticConfigVersion = _context3.sent;
          _context3.next = 5;
          return select(propsSelectors.getPropertyGroup);

        case 5:
          group = _context3.sent;
          _context3.next = 8;
          return call(staticConfig, group, staticConfigVersion);

        case 8:
          staticConfigResponse = _context3.sent;
          _context3.next = 11;
          return call(handleStaticConfigResponse, staticConfigResponse);

        case 11:
          _context3.next = 13;
          return select(propsSelectors.getPropertyDynamicConfig);

        case 13:
          dynamicConfigResponse = _context3.sent;
          serverConfig = _extends({}, dynamicConfigResponse, staticConfigResponse);
          _context3.next = 17;
          return call(handleServerConfig, serverConfig);

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$1);
}
function fetchTranslations() {
  var translationsVersion, translations, parsedTranslations;
  return _regeneratorRuntime.wrap(function fetchTranslations$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call(waitForState, propsSelectors.getPropertyTranslationsVersion);

        case 2:
          translationsVersion = _context4.sent;
          _context4.next = 5;
          return call(getWebservResource, translationsVersion + "?acao=true");

        case 5:
          translations = _context4.sent;
          parsedTranslations = mapKeys(function (key) {
            return key.toLowerCase();
          }, translations.localization);
          _context4.next = 9;
          return put(propsActions.setPropertyTranslations(parsedTranslations));

        case 9:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$1);
}

function setInitialVisitorData(dynamicConfigResponse) {
  var visitorData, visitorId, visitorDataToSet, params;
  return _regeneratorRuntime.wrap(function setInitialVisitorData$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return select(getVisitorData);

        case 2:
          visitorData = _context5.sent;
          _context5.next = 5;
          return select(propsSelectors.getPropertyVisitorId);

        case 5:
          visitorId = _context5.sent;
          visitorDataToSet = _extends({}, visitorData);

          if (!(typeof dynamicConfigResponse.visitor.groups !== 'undefined')) {
            _context5.next = 10;
            break;
          }

          _context5.next = 10;
          return put(propsActions.setPropertyGroup(dynamicConfigResponse.visitor.groups));

        case 10:
          _context5.next = 12;
          return put(propsActions.setPropertyStaticConfigVersion(dynamicConfigResponse.static_config_version));

        case 12:
          if (visitorData.name || dynamicConfigResponse.visitor.nick) {
            visitorDataToSet.name = visitorData.name || dynamicConfigResponse.visitor.nick;
          } // if (dynamicConfigResponse.visitor.params) {
          // visitorDataToSet.customProperties = {
          // 	...visitorDataToSet.customParams,
          // 	...decodeQueryString(dynamicConfigResponse.visitor.params),
          // }
          // }
          // Back to old LC2 bahaviour - setting __lc.params overrides custom params


          params = visitorDataToSet.customProperties || dynamicConfigResponse.visitor.params && decodeQueryString(dynamicConfigResponse.visitor.params);

          if (params) {
            visitorDataToSet.customProperties = params;
          }

          if (!(dynamicConfigResponse.visitor.nick || dynamicConfigResponse.visitor.params)) {
            _context5.next = 18;
            break;
          }

          _context5.next = 18;
          return put(setVisitorData({
            visitorData: visitorDataToSet
          }));

        case 18:
          if (visitorId) {
            _context5.next = 22;
            break;
          }

          _context5.next = 21;
          return put(propsActions.setPropertyVisitorId(dynamicConfigResponse.visitor.session));

        case 21:
          storage$1.setItem('visitorId', dynamicConfigResponse.visitor.session);

        case 22:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$1);
}

function handleDynamicConfigResponse(response) {
  var _parseInvitation, agent, invitation;

  return _regeneratorRuntime.wrap(function handleDynamicConfigResponse$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return call(setInitialVisitorData, response);

        case 2:
          _context6.next = 4;
          return put(propsActions.setPropertyDynamicConfig(response));

        case 4:
          _context6.next = 6;
          return put(propsActions.setPropertyClientLimitExceeded(response.client_limit_exceeded));

        case 6:
          if (!response.automatic_greeting) {
            _context6.next = 12;
            break;
          }

          _parseInvitation = parseInvitation(response.automatic_greeting), agent = _parseInvitation.agent, invitation = _parseInvitation.invitation;
          _context6.next = 10;
          return put(newAgent(_extends({}, agent, {
            fromInvitation: true
          })));

        case 10:
          _context6.next = 12;
          return put(newInvitation(invitation));

        case 12:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function checkProtocolVersion() {
  var _ref, staticConfigVersion, group, _ref2, licenseVersion;

  return _regeneratorRuntime.wrap(function checkProtocolVersion$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return call(dynamicConfig);

        case 2:
          _ref = _context7.sent;
          staticConfigVersion = _ref.static_config_version;
          group = _ref.visitor.groups;
          _context7.next = 7;
          return call(staticConfig, group, staticConfigVersion);

        case 7:
          _ref2 = _context7.sent;
          licenseVersion = _ref2.license_properties.lc_version;

          if (!(licenseVersion === '3')) {
            _context7.next = 12;
            break;
          }

          _context7.next = 12;
          return put(protocolUpgraded());

        case 12:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}
function _callee(serverConfig) {
  var dynamicConfigResponse;
  return _regeneratorRuntime.wrap(function _callee$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          if (!serverConfig) {
            _context8.next = 8;
            break;
          }

          _context8.next = 3;
          return call(handleDynamicConfigResponse, serverConfig);

        case 3:
          _context8.next = 5;
          return call(handleStaticConfigResponse, serverConfig);

        case 5:
          _context8.next = 7;
          return call(handleServerConfig, serverConfig);

        case 7:
          return _context8.abrupt("return");

        case 8:
          _context8.next = 10;
          return call(dynamicConfig);

        case 10:
          dynamicConfigResponse = _context8.sent;
          _context8.next = 13;
          return call(handleDynamicConfigResponse, dynamicConfigResponse);

        case 13:
          _context8.next = 15;
          return call(fetchStaticConfig);

        case 15:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

var parseCustomVariables = function parseCustomVariables(data) {
  return Object.keys(data).map(function (key) {
    return {
      name: String(key),
      value: String(data[key])
    };
  });
};

var CHATTING = 'CHATTING';
var NOT_CHATTING = 'NOT_CHATTING';

var _marked$4 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendMessage);
function sendMessage(_ref) {
  var customId, text, json, visitorId, requestBody;
  return _regeneratorRuntime.wrap(function sendMessage$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          customId = _ref.customId, text = _ref.text, json = _ref.json;
          _context.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context.sent;
          requestBody = {
            author: 'visitor',
            message: text,
            message_id: customId,
            random_id: customId,
            visitor: {
              id: visitorId
            }
          };

          if (json) {
            requestBody.message_json = JSON.stringify(json);
          }

          _context.next = 8;
          return call(sendJsonRequest, 'send_message', requestBody);

        case 8:
          _context.next = 10;
          return put({
            type: 'PRIVATE_SEND_MESSAGE'
          });

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$4);
}

var _marked$5 =
/*#__PURE__*/
_regeneratorRuntime.mark(closeChat);
function closeChat() {
  var visitorId, closeChatData;
  return _regeneratorRuntime.wrap(function closeChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          closeChatData = {
            source: 'visitor',
            random_id: String(Math.random()),
            visitor: {
              id: visitorId
            }
          };
          _context.next = 6;
          return call(sendJsonRequest, 'close_chat', closeChatData);

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$5);
}

var _marked$6 =
/*#__PURE__*/
_regeneratorRuntime.mark(requestForwardChatTranscript);
function requestForwardChatTranscript(action) {
  var visitorId, chatId, IwcsBody;
  return _regeneratorRuntime.wrap(function requestForwardChatTranscript$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyChatId);

        case 5:
          chatId = _context.sent;
          IwcsBody = {
            visitorId: visitorId,
            chatId: chatId,
            email: action.payload.email
          };
          _context.next = 9;
          return call(sendIWCSRequest, 'forwardChatTranscript', IwcsBody);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$6);
}

var _marked$7 =
/*#__PURE__*/
_regeneratorRuntime.mark(rateChat$1);
function rateChat$1(action) {
  var visitorId, chatId, IwcsBody;
  return _regeneratorRuntime.wrap(function rateChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyChatId);

        case 5:
          chatId = _context.sent;
          IwcsBody = {
            visitorId: visitorId,
            chatId: chatId,
            rate: action.payload.rate
          };
          _context.next = 9;
          return call(sendIWCSRequest, 'rateChat', IwcsBody);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$7);
}

var _marked$8 =
/*#__PURE__*/
_regeneratorRuntime.mark(getTicketForm);
function getTicketForm(group) {
  var license, IwcsBody;
  return _regeneratorRuntime.wrap(function getTicketForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyLicense);

        case 2:
          license = _context.sent;
          IwcsBody = {
            license: license,
            type: 'offline',
            group: group
          };
          _context.next = 6;
          return call(sendIWCSRequest, 'getCustomForm', IwcsBody);

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$8);
}

var _marked$9 =
/*#__PURE__*/
_regeneratorRuntime.mark(getQueueForm);
function getQueueForm() {
  var license, group, IwcsBody;
  return _regeneratorRuntime.wrap(function getQueueForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyLicense);

        case 2:
          license = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyGroup);

        case 5:
          group = _context.sent;
          IwcsBody = {
            license: license,
            type: 'queued',
            group: group
          };
          _context.next = 9;
          return call(sendIWCSRequest, 'getCustomForm', IwcsBody);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$9);
}

var _marked$a =
/*#__PURE__*/
_regeneratorRuntime.mark(sendChatComment);
function sendChatComment(action) {
  var visitorId, chatId, chatCommentBody;
  return _regeneratorRuntime.wrap(function sendChatComment$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyChatId);

        case 5:
          chatId = _context.sent;
          chatCommentBody = {
            comment: action.payload.comment,
            conference_id: chatId,
            random_id: String(Math.random()),
            visitor: {
              id: visitorId
            }
          };
          _context.next = 9;
          return call(sendJsonRequest, 'send_rating_comment', chatCommentBody);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$a);
}

var _marked$b =
/*#__PURE__*/
_regeneratorRuntime.mark(sendTicketForm);

var parseAnswers = function parseAnswers(answers, form) {
  var parsedMessageAnswers = mapKeys(function (fieldName) {
    return fieldName === 'message' ? 'textarea' : fieldName;
  }, answers);
  return form.fields.map(function (field) {
    if (field.type === 'information') {
      return null;
    }

    var answer = {
      type: field.type,
      text: field.label,
      serverType: field.serverType // @andarist:
      // I have no idea how we can hit field.type branch, but I'm too afraid to just remove it right now

    };

    if (field.name in parsedMessageAnswers || field.type in parsedMessageAnswers) {
      if ('options' in field) {
        answer.value = ensureArray(parsedMessageAnswers[field.name]).map(function (value) {
          return find(function (option) {
            return option.value === value;
          }, field.options).label;
        }).join(', ');
      } else if (field.name in parsedMessageAnswers) {
        answer.value = parsedMessageAnswers[field.name];
      } else {
        answer.value = parsedMessageAnswers[field.type];
      }

      answer.value = trimEnd(answer.value);
      answer.text = answer.text + " " + answer.value;
    }

    return answer;
  }).filter(Boolean);
};

var getTicketFormRequestBody = function getTicketFormRequestBody(_ref, ticketForm, answers) {
  var group = _ref.group,
      license = _ref.license,
      visitorId = _ref.visitorId,
      visitorData = _ref.visitorData,
      defaultValues = _ref.defaultValues;
  var parsedAnswers = parseAnswers(answers, ticketForm);
  var email = find(function (answer) {
    return answer.type === 'email' || answer.serverType === 'email';
  }, parsedAnswers);

  if (!email) {
    // eslint-disable-next-line no-throw-literal
    throw {
      type: 'missing argument',
      reason: 'Missing email'
    };
  } // should be message, need to refactor in sdk


  var message = find(function (answer) {
    return answer.type === 'textarea';
  }, parsedAnswers);

  if (!message) {
    // eslint-disable-next-line no-throw-literal
    throw {
      type: 'missing argument',
      reason: 'Missing message'
    };
  }

  var name = find(function (answer) {
    return answer.type === 'name' || answer.serverType === 'name';
  }, parsedAnswers);
  var subjectField = find(function (answer) {
    return answer.type === 'subject' || answer.serverType === 'subject';
  }, parsedAnswers);
  var ticketMessage = parsedAnswers.filter(function (_ref2) {
    var type = _ref2.type,
        serverType = _ref2.serverType;
    return ['name', 'email', 'subject'].indexOf(serverType || type) === -1;
  }).map(function (_ref3) {
    var text = _ref3.text;
    return text;
  }).join('\n');
  var requester = {
    mail: email.value
  };

  if (name) {
    requester.name = name.value;
  } else if (defaultValues && defaultValues.name) {
    requester.name = defaultValues.name;
  }

  var body = {
    group: group,
    licence_id: license,
    ticket_message: ticketMessage,
    offline_message: parsedAnswers.map(function (_ref4) {
      var text = _ref4.text;
      return text;
    }).join('\n'),
    requester: requester,
    visitor_id: visitorId // don't send empty strings as subject, we want it to be defaulted to "(no subject)" by the API
    // https://github.com/livechat/livechat-docs/blame/6747dfc992a9f4bebb9b507a83ae286340267a0b/livechat2/rest-api/docs/tickets.md#L57

  };

  if (subjectField && subjectField.value) {
    body.subject = subjectField.value;
  }

  if (visitorData.pageUrl) {
    body.source = {
      url: visitorData.pageUrl
    };
  }

  return body;
};
var createSendTicketFormResponse = function createSendTicketFormResponse(id, requestBody) {
  var response = {
    id: id,
    text: requestBody.ticket_message,
    visitor: {
      name: requestBody.requester.name || null,
      email: requestBody.requester.mail || null
    }
  };

  if (requestBody.subject) {
    response.subject = requestBody.subject;
  }

  return response;
};
function sendTicketForm(payload) {
  var group, license, visitorId, visitorData, ticketForm, translations, defaultValues, body, response, firstError, type;
  return _regeneratorRuntime.wrap(function sendTicketForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyGroup);

        case 2:
          group = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyLicense);

        case 5:
          license = _context.sent;
          _context.next = 8;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 8:
          visitorId = _context.sent;
          _context.next = 11;
          return select(getVisitorData);

        case 11:
          visitorData = _context.sent;
          _context.next = 14;
          return select(propsSelectors.getPropertyTicketForm);

        case 14:
          ticketForm = _context.sent;
          _context.next = 17;
          return select(propsSelectors.getPropertyTranslations);

        case 17:
          translations = _context.sent;
          defaultValues = translations ? {
            name: translations.client
          } : {};
          body = getTicketFormRequestBody({
            group: group,
            license: license,
            visitorId: visitorId,
            visitorData: visitorData,
            defaultValues: defaultValues
          }, ticketForm, payload.answers);
          _context.next = 22;
          return call(sendApiRequest, 'v2/tickets/new', body);

        case 22:
          response = _context.sent;

          if (!response.errors) {
            _context.next = 27;
            break;
          }

          // we receive some hardcore aggregate error here 😱
          firstError = response.errors[0];
          type = Object.keys(firstError)[0];
          throw {
            type: type,
            reason: firstError[type][0]
          };

        case 27:
          return _context.abrupt("return", createSendTicketFormResponse(response.id, body));

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$b);
}

var _marked$c =
/*#__PURE__*/
_regeneratorRuntime.mark(requestAttachmentToken);
function requestAttachmentToken(payload) {
  var visitorId, customId, chatId, requestData;
  return _regeneratorRuntime.wrap(function requestAttachmentToken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          customId = payload.customId;
          _context.next = 6;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 6:
          chatId = _context.sent;
          requestData = {
            random_id: customId,
            conference_id: chatId,
            visitor: {
              id: visitorId
            },
            valid_time_sec: 60
          };
          _context.next = 10;
          return call(sendJsonRequest, 'attachment_token', requestData);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$c);
}

var _marked$d =
/*#__PURE__*/
_regeneratorRuntime.mark(getPostChat);
function getPostChat() {
  var license, group, IWCSBody;
  return _regeneratorRuntime.wrap(function getPostChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyLicense);

        case 2:
          license = _context.sent;
          _context.next = 5;
          return select(propsSelectors.getPropertyGroup);

        case 5:
          group = _context.sent;
          IWCSBody = {
            type: 'postchat',
            license: license,
            group: group
          };
          _context.next = 9;
          return call(sendIWCSRequest, 'getForm', IWCSBody);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$d);
}

var _marked$e =
/*#__PURE__*/
_regeneratorRuntime.mark(sendPostChat);
function sendPostChat(_ref) {
  var answers, visitorId, chatId, postChatData;
  return _regeneratorRuntime.wrap(function sendPostChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          answers = _ref.answers;
          _context.next = 3;
          return select(propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context.sent;
          _context.next = 6;
          return select(propsSelectors.getPropertyChatId);

        case 6:
          chatId = _context.sent;
          postChatData = {
            conference_id: chatId,
            random_id: String(Math.random()),
            survey: answers,
            visitor: {
              id: visitorId
            }
          };
          _context.next = 10;
          return call(sendJsonRequest, 'post_chat_survey_data', postChatData);

        case 10:
          return _context.abrupt("return", _context.sent);

        case 11:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$e);
}

var _marked$f =
/*#__PURE__*/
_regeneratorRuntime.mark(getPredictedAgent);
function getPredictedAgent() {
  var visitorId, requestData;
  return _regeneratorRuntime.wrap(function getPredictedAgent$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 2:
          visitorId = _context.sent;
          requestData = {
            random_id: String(Math.random()),
            visitor: {
              id: visitorId
            }
          };
          _context.next = 6;
          return call(sendJsonRequest, 'get_predicted_agent', requestData);

        case 6:
          return _context.abrupt("return", _context.sent);

        case 7:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$f);
}

var _marked$g =
/*#__PURE__*/
_regeneratorRuntime.mark(markMessageAsSeen);
function markMessageAsSeen(_ref) {
  var messageId, visitorId, serverIdsMap, _serverIdsMap$message, serverId, authorId, messageData;

  return _regeneratorRuntime.wrap(function markMessageAsSeen$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          messageId = _ref.messageId;
          _context.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context.sent;
          _context.next = 6;
          return select(propsSelectors.getPropertyServerIdsMap);

        case 6:
          serverIdsMap = _context.sent;
          _serverIdsMap$message = serverIdsMap[messageId], serverId = _serverIdsMap$message.serverId, authorId = _serverIdsMap$message.authorId;
          messageData = {
            message: {
              id: serverId,
              agent_id: authorId
            },
            random_id: String(Math.random()),
            visitor: {
              id: visitorId
            }
          };
          _context.next = 11;
          return call(sendJsonRequest, 'agent_message_seen', messageData);

        case 11:
          return _context.abrupt("return", _context.sent);

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$g);
}

var ONLINE = 'ONLINE';
var OFFLINE = 'OFFLINE';

var _marked$h =
/*#__PURE__*/
_regeneratorRuntime.mark(statusPing);
function statusPing(group) {
  var groupToCheck, visitorId, requestBody;
  return _regeneratorRuntime.wrap(function statusPing$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(typeof group !== 'undefined')) {
            _context.next = 4;
            break;
          }

          _context.t0 = group;
          _context.next = 7;
          break;

        case 4:
          _context.next = 6;
          return select(propsSelectors.getPropertyGroup);

        case 6:
          _context.t0 = _context.sent;

        case 7:
          groupToCheck = _context.t0;
          _context.next = 10;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 10:
          visitorId = _context.sent;
          requestBody = {
            visitor: {
              id: visitorId
            },
            skill: groupToCheck,
            random_id: String(Math.random())
          };
          _context.next = 14;
          return call(sendJsonRequest, 'status_ping', requestBody, {
            retry: 10
          });

        case 14:
          return _context.abrupt("return", _context.sent);

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$h);
}
var parseResponseToChatStatus = function parseResponseToChatStatus(response) {
  return {
    chatState: response.visitor_is_chatting ? CHATTING : NOT_CHATTING,
    chatStatus: response.agent_available ? ONLINE : OFFLINE
  };
};

var _marked$i =
/*#__PURE__*/
_regeneratorRuntime.mark(getTranslations),
    _marked2$3 =
/*#__PURE__*/
_regeneratorRuntime.mark(getWelcomeMessage),
    _marked4$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendMessageHandler),
    _marked5$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(setVisitorDataHandler),
    _marked6$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(setSneakPeekHandler),
    _marked7$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(forwardChatTranscriptHandler),
    _marked8$1 =
/*#__PURE__*/
_regeneratorRuntime.mark(closeChatHandler),
    _marked9 =
/*#__PURE__*/
_regeneratorRuntime.mark(rateChatHandler),
    _marked10 =
/*#__PURE__*/
_regeneratorRuntime.mark(disconnectHandler),
    _marked11 =
/*#__PURE__*/
_regeneratorRuntime.mark(getTicketFormHandler),
    _marked12 =
/*#__PURE__*/
_regeneratorRuntime.mark(getQueueFormHandler),
    _marked13 =
/*#__PURE__*/
_regeneratorRuntime.mark(getTranslationsHandler),
    _marked14 =
/*#__PURE__*/
_regeneratorRuntime.mark(getVisitorDataHandler),
    _marked15 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendTicketFormHandler),
    _marked16 =
/*#__PURE__*/
_regeneratorRuntime.mark(fetchPrechat),
    _marked17 =
/*#__PURE__*/
_regeneratorRuntime.mark(getPreChatFormHandler),
    _marked18 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendPreChatFormHandler),
    _marked19 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendFileHandler),
    _marked20 =
/*#__PURE__*/
_regeneratorRuntime.mark(getPredictedAgentHandler),
    _marked21 =
/*#__PURE__*/
_regeneratorRuntime.mark(getPostChatFormHandler),
    _marked22 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendPostChatFormHandler),
    _marked23 =
/*#__PURE__*/
_regeneratorRuntime.mark(getConfigHandler),
    _marked24 =
/*#__PURE__*/
_regeneratorRuntime.mark(acceptInvitationHandler),
    _marked25 =
/*#__PURE__*/
_regeneratorRuntime.mark(markMessageAsSeenHandler),
    _marked26 =
/*#__PURE__*/
_regeneratorRuntime.mark(startChatHandler),
    _marked27 =
/*#__PURE__*/
_regeneratorRuntime.mark(checkGroupStatusHandler),
    _marked28 =
/*#__PURE__*/
_regeneratorRuntime.mark(oldVisitorPingerStopper),
    _marked29 =
/*#__PURE__*/
_regeneratorRuntime.mark(setVisitorDataTask),
    _marked30 =
/*#__PURE__*/
_regeneratorRuntime.mark(setVisitorGroupHandler),
    _marked31 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee$1);
var PING_MAXIMUM_TIME_ON_PAGE = 1000 * 60 * 30; // 30 Minutes

var publicSendMessage$1 = publicSendMessage,
    publicSetVisitorData$1 = publicSetVisitorData,
    publicGetVisitorData$1 = publicGetVisitorData,
    publicRateChat$1 = publicRateChat,
    publicSetSneakPeek$1 = publicSetSneakPeek,
    publicForwardChatTranscript$1 = publicForwardChatTranscript,
    publicCloseChat$1 = publicCloseChat,
    publicDisconnect$1 = publicDisconnect,
    publicGetTicketForm$1 = publicGetTicketForm,
    publicSendTicketForm$1 = publicSendTicketForm,
    publicSendFile$1 = publicSendFile,
    publicGetPrechatForm$1 = publicGetPrechatForm,
    publicSendPrechatForm$1 = publicSendPrechatForm,
    publicGetTranslations$1 = publicGetTranslations,
    publicGetPredictedAgent$1 = publicGetPredictedAgent,
    publicGetPostChatForm$1 = publicGetPostChatForm,
    publicSendPostChatForm$1 = publicSendPostChatForm,
    publicGetConfig$1 = publicGetConfig,
    publicAcceptInvitation$1 = publicAcceptInvitation,
    publicMarkMessageAsSeen$1 = publicMarkMessageAsSeen,
    publicStartChat$1 = publicStartChat,
    publicCheckGroupStatus$1 = publicCheckGroupStatus,
    publicSetVisitorGroup$1 = publicSetVisitorGroup,
    publicGetQueueForm$1 = publicGetQueueForm;
function getTranslations() {
  var translations;
  return _regeneratorRuntime.wrap(function getTranslations$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyTranslations);

        case 2:
          translations = _context.sent;

          if (!translations) {
            _context.next = 5;
            break;
          }

          return _context.abrupt("return", translations);

        case 5:
          _context.next = 7;
          return call(fetchTranslations);

        case 7:
          _context.next = 9;
          return select(propsSelectors.getPropertyTranslations);

        case 9:
          return _context.abrupt("return", _context.sent);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$i);
}

function getWelcomeMessage() {
  var welcomeMessage;
  return _regeneratorRuntime.wrap(function getWelcomeMessage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return select(propsSelectors.getPropertyWelcomeMessage);

        case 2:
          welcomeMessage = _context2.sent;

          if (!welcomeMessage) {
            _context2.next = 5;
            break;
          }

          return _context2.abrupt("return", welcomeMessage);

        case 5:
          _context2.next = 7;
          return call(getTranslations);

        case 7:
          return _context2.abrupt("return", _context2.sent.welcome_to_chat);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$3);
}

function sendMessageHandler(action) {
  var _marked3, chatState, _action$payload, customId, text, json, notChatting, acceptedInvitation, createTakeTask, takeTask, chatAction, incomingResponse;

  return _regeneratorRuntime.wrap(function sendMessageHandler$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          createTakeTask = function _ref() {
            return _regeneratorRuntime.wrap(function createTakeTask$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return take(function (reduxAction) {
                      return reduxAction.type === newMessage.getActionName() && get('payload.customId', reduxAction) === customId;
                    });

                  case 2:
                    return _context3.abrupt("return", _context3.sent);

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _marked3);
          };

          _marked3 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(createTakeTask);
          _context4.next = 4;
          return call(waitForState, propsSelectors.getPropertyChatState);

        case 4:
          chatState = _context4.sent;
          _action$payload = action.payload, customId = _action$payload.customId, text = _action$payload.text, json = _action$payload.json;
          notChatting = chatState !== CHATTING;
          _context4.next = 9;
          return select(propsSelectors.getPropertyAcceptedInvitation);

        case 9:
          acceptedInvitation = _context4.sent;
          _context4.next = 12;
          return fork(createTakeTask);

        case 12:
          takeTask = _context4.sent;
          _context4.prev = 13;

          if (!notChatting) {
            _context4.next = 28;
            break;
          }

          _context4.t0 = call;
          _context4.t1 = startChat;
          _context4.t2 = customId;
          _context4.t3 = text;
          _context4.next = 21;
          return call(getWelcomeMessage);

        case 21:
          _context4.t4 = _context4.sent;
          _context4.t5 = acceptedInvitation;
          _context4.t6 = {
            customId: _context4.t2,
            text: _context4.t3,
            welcomeMessage: _context4.t4,
            acceptedInvitation: _context4.t5
          };
          _context4.next = 26;
          return (0, _context4.t0)(_context4.t1, _context4.t6);

        case 26:
          _context4.next = 30;
          break;

        case 28:
          _context4.next = 30;
          return call(sendMessage, {
            customId: customId,
            text: text,
            json: json
          });

        case 30:
          _context4.next = 38;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t7 = _context4["catch"](13);
          action.payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });
          _context4.next = 37;
          return cancel(takeTask);

        case 37:
          return _context4.abrupt("return");

        case 38:
          if (!notChatting) {
            _context4.next = 45;
            break;
          }

          _context4.next = 41;
          return take([newAgent.getActionName(), chatEnded.getActionName()]);

        case 41:
          chatAction = _context4.sent;

          if (!(chatAction.type === chatEnded.getActionName())) {
            _context4.next = 45;
            break;
          }

          action.payload.promise.reject({
            type: 'state',
            reason: 'Chat is offline'
          });
          return _context4.abrupt("return");

        case 45:
          _context4.next = 47;
          return join(takeTask);

        case 47:
          incomingResponse = _context4.sent;
          action.payload.promise.resolve({
            id: incomingResponse.payload.id,
            timestamp: incomingResponse.payload.timestamp
          });

        case 49:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$2, null, [[13, 32]]);
}

function setVisitorDataHandler(action) {
  var visitorData, visitorDataWithoutCustomProperties, parsedNewVisitorData, requestId, newVisitorData, setAction;
  return _regeneratorRuntime.wrap(function setVisitorDataHandler$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(waitForState, propsSelectors.getPropertyClientLimitExceeded);

        case 2:
          _context5.next = 4;
          return select(getVisitorData);

        case 4:
          visitorData = _context5.sent;
          visitorDataWithoutCustomProperties = omit(['customProperties'], visitorData);
          parsedNewVisitorData = omitBy(isNil, pick(['name', 'email', 'pageUrl', 'pageTitle', 'customProperties'], action.payload));
          requestId = String(Math.random());
          newVisitorData = action.payload.update ? merge(visitorData, parsedNewVisitorData) : merge(visitorDataWithoutCustomProperties, parsedNewVisitorData);
          _context5.next = 11;
          return put(setVisitorData({
            requestId: requestId,
            visitorData: newVisitorData
          }));

        case 11:
          _context5.next = 13;
          return take(function (anyAction) {
            return (anyAction.type === visitorDataSet.getActionName() || anyAction.type === visitorDataSetError.getActionName()) && anyAction.payload.requestId === requestId;
          });

        case 13:
          setAction = _context5.sent;

          if (!(setAction.type === visitorDataSet.getActionName())) {
            _context5.next = 16;
            break;
          }

          return _context5.abrupt("return", action.payload.promise.resolve(setAction.payload.visitorData));

        case 16:
          return _context5.abrupt("return", action.payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 17:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$2);
}

function setSneakPeekHandler(action) {
  return _regeneratorRuntime.wrap(function setSneakPeekHandler$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return put(propsActions.setPropertySneakPeek(action.payload.text));

        case 2:
          action.payload.promise.resolve({
            success: true
          });

        case 3:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6$1);
}

function forwardChatTranscriptHandler(action) {
  var chatId;
  return _regeneratorRuntime.wrap(function forwardChatTranscriptHandler$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return select(propsSelectors.getPropertyChatId);

        case 2:
          chatId = _context7.sent;

          if (chatId) {
            _context7.next = 6;
            break;
          }

          action.payload.promise.reject({
            type: 'state',
            reason: 'There is no chat to forward transcript'
          });
          return _context7.abrupt("return");

        case 6:
          _context7.prev = 6;
          _context7.next = 9;
          return call(requestForwardChatTranscript, action);

        case 9:
          _context7.next = 15;
          break;

        case 11:
          _context7.prev = 11;
          _context7.t0 = _context7["catch"](6);
          action.payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });
          return _context7.abrupt("return");

        case 15:
          action.payload.promise.resolve({
            success: true
          });

        case 16:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7$1, null, [[6, 11]]);
}

function closeChatHandler(action) {
  var chatId;
  return _regeneratorRuntime.wrap(function closeChatHandler$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return select(propsSelectors.getPropertyChatId);

        case 2:
          chatId = _context8.sent;

          if (chatId) {
            _context8.next = 6;
            break;
          }

          action.payload.promise.reject({
            type: 'state',
            reason: 'There is no chat to close'
          });
          return _context8.abrupt("return");

        case 6:
          _context8.prev = 6;
          _context8.next = 9;
          return call(closeChat);

        case 9:
          _context8.next = 15;
          break;

        case 11:
          _context8.prev = 11;
          _context8.t0 = _context8["catch"](6);
          action.payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });
          return _context8.abrupt("return");

        case 15:
          _context8.next = 17;
          return take(chatEnded.getActionName());

        case 17:
          action.payload.promise.resolve({
            success: true
          });

        case 18:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8$1, null, [[6, 11]]);
}

function rateChatHandler(action) {
  var chatId;
  return _regeneratorRuntime.wrap(function rateChatHandler$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return select(propsSelectors.getPropertyChatId);

        case 2:
          chatId = _context9.sent;

          if (chatId) {
            _context9.next = 6;
            break;
          }

          action.payload.promise.reject({
            type: 'state',
            reason: 'There is no chat to rate'
          });
          return _context9.abrupt("return");

        case 6:
          if (!action.payload.rate) {
            _context9.next = 16;
            break;
          }

          _context9.prev = 7;
          _context9.next = 10;
          return call(rateChat$1, action);

        case 10:
          _context9.next = 16;
          break;

        case 12:
          _context9.prev = 12;
          _context9.t0 = _context9["catch"](7);
          action.payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });
          return _context9.abrupt("return");

        case 16:
          if (!action.payload.comment) {
            _context9.next = 26;
            break;
          }

          _context9.prev = 17;
          _context9.next = 20;
          return call(sendChatComment, action);

        case 20:
          _context9.next = 26;
          break;

        case 22:
          _context9.prev = 22;
          _context9.t1 = _context9["catch"](17);
          action.payload.promise.reject({
            type: 'connection',
            reason: 'Rate Comment request failed'
          });
          return _context9.abrupt("return");

        case 26:
          action.payload.promise.resolve({
            success: true
          });

        case 27:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9, null, [[7, 12], [17, 22]]);
}

function disconnectHandler(_ref2) {
  var payload, chatState;
  return _regeneratorRuntime.wrap(function disconnectHandler$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          payload = _ref2.payload;
          _context10.next = 3;
          return select(propsSelectors.getPropertyChatState);

        case 3:
          chatState = _context10.sent;

          if (!(chatState === CHATTING)) {
            _context10.next = 7;
            break;
          }

          payload.promise.reject({
            type: 'state',
            reason: "You can't disconnect during the chat"
          });
          return _context10.abrupt("return");

        case 7:
          payload.promise.resolve({
            success: true
          });

        case 8:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

function getTicketFormHandler(_ref3) {
  var payload, promise, group, offlineFormResponse, parsedOfflineFormResponse, offlineForm, ticketForm;
  return _regeneratorRuntime.wrap(function getTicketFormHandler$(_context11) {
    while (1) {
      switch (_context11.prev = _context11.next) {
        case 0:
          payload = _ref3.payload;
          promise = payload.promise, group = payload.group;

          if (!(typeof group !== 'undefined')) {
            _context11.next = 18;
            break;
          }

          _context11.prev = 3;
          _context11.next = 6;
          return call(getTicketForm, group);

        case 6:
          offlineFormResponse = _context11.sent;
          parsedOfflineFormResponse = translateIWCS(offlineFormResponse.join('^'));
          offlineForm = ensureTicketFormRequiredFields(translateForm(parsedOfflineFormResponse.data.json));
          _context11.next = 11;
          return put(propsActions.setPropertyTicketForm(offlineForm));

        case 11:
          promise.resolve(offlineForm);
          _context11.next = 17;
          break;

        case 14:
          _context11.prev = 14;
          _context11.t0 = _context11["catch"](3);
          promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });

        case 17:
          return _context11.abrupt("return");

        case 18:
          _context11.next = 20;
          return call(waitForState, propsSelectors.getPropertyTicketForm);

        case 20:
          ticketForm = _context11.sent;
          promise.resolve(ticketForm);

        case 22:
        case "end":
          return _context11.stop();
      }
    }
  }, _marked11, null, [[3, 14]]);
}

function getQueueFormHandler(_ref4) {
  var payload, promise, queueForm, parsed;
  return _regeneratorRuntime.wrap(function getQueueFormHandler$(_context12) {
    while (1) {
      switch (_context12.prev = _context12.next) {
        case 0:
          payload = _ref4.payload;
          promise = payload.promise;
          _context12.prev = 2;
          _context12.next = 5;
          return call(getQueueForm);

        case 5:
          queueForm = _context12.sent;
          parsed = translateIWCS(queueForm.join('^'));
          promise.resolve(translateForm(parsed.data.json));
          _context12.next = 13;
          break;

        case 10:
          _context12.prev = 10;
          _context12.t0 = _context12["catch"](2);
          promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });

        case 13:
        case "end":
          return _context12.stop();
      }
    }
  }, _marked12, null, [[2, 10]]);
}

function getTranslationsHandler(_ref5) {
  var payload, translations;
  return _regeneratorRuntime.wrap(function getTranslationsHandler$(_context13) {
    while (1) {
      switch (_context13.prev = _context13.next) {
        case 0:
          payload = _ref5.payload;
          _context13.prev = 1;
          _context13.next = 4;
          return call(getTranslations);

        case 4:
          translations = _context13.sent;
          return _context13.abrupt("return", payload.promise.resolve(translations));

        case 8:
          _context13.prev = 8;
          _context13.t0 = _context13["catch"](1);
          return _context13.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 11:
        case "end":
          return _context13.stop();
      }
    }
  }, _marked13, null, [[1, 8]]);
}

function getVisitorDataHandler(_ref6) {
  var payload, visitorData;
  return _regeneratorRuntime.wrap(function getVisitorDataHandler$(_context14) {
    while (1) {
      switch (_context14.prev = _context14.next) {
        case 0:
          payload = _ref6.payload;
          _context14.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          _context14.next = 5;
          return select(getVisitorData);

        case 5:
          visitorData = _context14.sent;
          return _context14.abrupt("return", payload.promise.resolve(visitorData));

        case 7:
        case "end":
          return _context14.stop();
      }
    }
  }, _marked14);
}

function sendTicketFormHandler(_ref7) {
  var payload;
  return _regeneratorRuntime.wrap(function sendTicketFormHandler$(_context15) {
    while (1) {
      switch (_context15.prev = _context15.next) {
        case 0:
          payload = _ref7.payload;
          _context15.next = 3;
          return call(waitForState, propsSelectors.getPropertyTicketForm);

        case 3:
          _context15.prev = 3;
          _context15.t0 = payload.promise;
          _context15.next = 7;
          return call(sendTicketForm, payload);

        case 7:
          _context15.t1 = _context15.sent;

          _context15.t0.resolve.call(_context15.t0, _context15.t1);

          _context15.next = 14;
          break;

        case 11:
          _context15.prev = 11;
          _context15.t2 = _context15["catch"](3);
          payload.promise.reject(_context15.t2 && _context15.t2.reason || _context15.t2 && _context15.t2.errors ? _context15.t2 : {
            type: 'connection',
            reason: 'Request failed'
          });

        case 14:
        case "end":
          return _context15.stop();
      }
    }
  }, _marked15, null, [[3, 11]]);
}

function fetchPrechat() {
  var preChatForm;
  return _regeneratorRuntime.wrap(function fetchPrechat$(_context16) {
    while (1) {
      switch (_context16.prev = _context16.next) {
        case 0:
          _context16.next = 2;
          return call(waitForState, propsSelectors.getPropertyConfigLoaded);

        case 2:
          _context16.next = 4;
          return select(propsSelectors.getPropertyPreChatForm);

        case 4:
          preChatForm = _context16.sent;

          if (preChatForm) {
            _context16.next = 7;
            break;
          }

          return _context16.abrupt("return", null);

        case 7:
          return _context16.abrupt("return", preChatForm);

        case 8:
        case "end":
          return _context16.stop();
      }
    }
  }, _marked16);
}

function getPreChatFormHandler(_ref8) {
  var payload, preChatForm;
  return _regeneratorRuntime.wrap(function getPreChatFormHandler$(_context17) {
    while (1) {
      switch (_context17.prev = _context17.next) {
        case 0:
          payload = _ref8.payload;
          _context17.prev = 1;
          _context17.next = 4;
          return call(fetchPrechat);

        case 4:
          preChatForm = _context17.sent;

          if (preChatForm) {
            _context17.next = 7;
            break;
          }

          return _context17.abrupt("return", payload.promise.reject({
            type: 'state',
            reason: 'Pre-chat survey is turned off'
          }));

        case 7:
          return _context17.abrupt("return", payload.promise.resolve(preChatForm));

        case 10:
          _context17.prev = 10;
          _context17.t0 = _context17["catch"](1);
          return _context17.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 13:
        case "end":
          return _context17.stop();
      }
    }
  }, _marked17, null, [[1, 10]]);
}

var stringAnswerFieldTypes = ['email', 'text', 'radio', 'select', 'group_select'];
var arrayAnswerFieldTypes = ['checkbox'];

var validateForm = function validateForm(preChatFormFields, answers) {
  return preChatFormFields.map(function (field) {
    var answer = answers[field.name];
    var answerType = typeof answers[field.name];

    if (field.required && !answer) {
      return {
        reason: 'Required field',
        description: 'Pease fill in required field',
        field: field.name
      };
    }

    if (answer && stringAnswerFieldTypes.indexOf(field.type) !== -1 && answerType !== 'string') {
      return {
        reason: 'Wrong type',
        field: field.name
      };
    }

    if (answer && arrayAnswerFieldTypes.indexOf(field.type) !== -1 && !Array.isArray(answer)) {
      return {
        reason: 'Wrong type',
        field: field.name
      };
    }

    return false;
  }).filter(Boolean);
};

function sendPreChatFormHandler(_ref9) {
  var payload, chatState, currentVisitorData, preChatForm, answerData, promise, choosenGroupIndex, answers, acceptedInvitation, parsedAnswers, errors, visitorDataFromPrechat, parsedVisitorData;
  return _regeneratorRuntime.wrap(function sendPreChatFormHandler$(_context18) {
    while (1) {
      switch (_context18.prev = _context18.next) {
        case 0:
          payload = _ref9.payload;
          _context18.next = 3;
          return call(waitForState, propsSelectors.getPropertyChatState);

        case 3:
          chatState = _context18.sent;
          _context18.prev = 4;

          if (!(chatState === CHATTING)) {
            _context18.next = 7;
            break;
          }

          return _context18.abrupt("return", payload.promise.reject({
            type: 'state',
            reason: "You can't send prechat when chat is running"
          }));

        case 7:
          _context18.next = 9;
          return select(getVisitorData);

        case 9:
          currentVisitorData = _context18.sent;
          _context18.next = 12;
          return call(fetchPrechat);

        case 12:
          preChatForm = _context18.sent;
          answerData = payload.answers, promise = payload.promise;
          choosenGroupIndex = answerData.choosenGroupIndex, answers = _objectWithoutPropertiesLoose(answerData, ["choosenGroupIndex"]);
          _context18.next = 17;
          return select(propsSelectors.getPropertyAcceptedInvitation);

        case 17:
          acceptedInvitation = _context18.sent;
          parsedAnswers = translateFormAnswers(answers, preChatForm, choosenGroupIndex);
          errors = validateForm(preChatForm.fields, answers);

          if (!(errors.length !== 0)) {
            _context18.next = 22;
            break;
          }

          return _context18.abrupt("return", promise.reject({
            type: 'wrong arguments',
            fields: errors
          }));

        case 22:
          visitorDataFromPrechat = parsedAnswers.fields.filter(function (field) {
            return field.type === 'email' || field.type === 'name';
          });

          if (!visitorDataFromPrechat) {
            _context18.next = 27;
            break;
          }

          parsedVisitorData = visitorDataFromPrechat.reduce(function (visitorData, currentField) {
            var _extends2;

            return _extends({}, visitorData, (_extends2 = {}, _extends2[currentField.type] = currentField.answer, _extends2));
          }, currentVisitorData);
          _context18.next = 27;
          return put(setVisitorData({
            visitorData: parsedVisitorData
          }));

        case 27:
          _context18.t0 = call;
          _context18.t1 = startChat;
          _context18.t2 = parsedAnswers;
          _context18.next = 32;
          return call(getWelcomeMessage);

        case 32:
          _context18.t3 = _context18.sent;
          _context18.t4 = acceptedInvitation;
          _context18.t5 = {
            customId: 'prechat_startchat',
            answers: _context18.t2,
            welcomeMessage: _context18.t3,
            acceptedInvitation: _context18.t4
          };
          _context18.next = 37;
          return (0, _context18.t0)(_context18.t1, _context18.t5);

        case 37:
          _context18.next = 39;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 39:
          return _context18.abrupt("return", promise.resolve({
            success: true
          }));

        case 42:
          _context18.prev = 42;
          _context18.t6 = _context18["catch"](4);
          return _context18.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 45:
        case "end":
          return _context18.stop();
      }
    }
  }, _marked18, null, [[4, 42]]);
}

function sendFileHandler(_ref10) {
  var payload, chatState, environment, license, region, customId, file, onProgress, chatId, tokenResponse, token, newFileEvent;
  return _regeneratorRuntime.wrap(function sendFileHandler$(_context19) {
    while (1) {
      switch (_context19.prev = _context19.next) {
        case 0:
          payload = _ref10.payload;
          _context19.next = 3;
          return call(waitForState, propsSelectors.getPropertyChatState);

        case 3:
          chatState = _context19.sent;
          _context19.next = 6;
          return select(getEnvironment);

        case 6:
          environment = _context19.sent;
          _context19.next = 9;
          return select(propsSelectors.getPropertyLicense);

        case 9:
          license = _context19.sent;
          _context19.next = 12;
          return select(propsSelectors.getPropertyRegion);

        case 12:
          region = _context19.sent;
          customId = payload.customId, file = payload.file, onProgress = payload.onProgress;
          _context19.prev = 14;

          if (!(chatState !== CHATTING)) {
            _context19.next = 18;
            break;
          }

          _context19.next = 18;
          return call(startChat, {
            customId: customId + '_startchat',
            text: ''
          });

        case 18:
          _context19.next = 20;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 20:
          chatId = _context19.sent;
          _context19.next = 23;
          return call(requestAttachmentToken, payload);

        case 23:
          tokenResponse = _context19.sent;
          token = tokenResponse.attachment_token;
          _context19.next = 27;
          return call(sendFileToAPI, {
            environment: environment,
            region: region,
            license: license,
            token: token,
            file: file,
            chatId: chatId,
            onProgress: onProgress
          });

        case 27:
          _context19.next = 29;
          return take(function (action) {
            return action.type === newFile.getActionName() && action.payload.attachmentToken === token;
          });

        case 29:
          newFileEvent = _context19.sent;
          return _context19.abrupt("return", payload.promise.resolve(omitBy(isNil, pick(['id', 'timestamp', 'url', 'contentType', 'size', 'width', 'height'], newFileEvent.payload))));

        case 33:
          _context19.prev = 33;
          _context19.t0 = _context19["catch"](14);
          return _context19.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 36:
        case "end":
          return _context19.stop();
      }
    }
  }, _marked19, null, [[14, 33]]);
}

var pingSent = function pingSent(_ref11) {
  var type = _ref11.type,
      payload = _ref11.payload;
  return type === propsActions.setPropertyPingSent.getActionName() && payload.data === true;
};

function getPredictedAgentHandler(_ref12) {
  var payload, limit, getPredictedAgentResponse, translations, _getPredictedAgentRes, login, name, avatarUrl, jobTitle, isBot, welcomeMesssage, agent;

  return _regeneratorRuntime.wrap(function getPredictedAgentHandler$(_context20) {
    while (1) {
      switch (_context20.prev = _context20.next) {
        case 0:
          payload = _ref12.payload;
          _context20.prev = 1;
          _context20.next = 4;
          return call(waitForState, propsSelectors.getPropertyClientLimitExceeded);

        case 4:
          limit = _context20.sent;

          if (!limit) {
            _context20.next = 8;
            break;
          }

          _context20.next = 8;
          return take(pingSent);

        case 8:
          _context20.next = 10;
          return call(getPredictedAgent);

        case 10:
          getPredictedAgentResponse = _context20.sent;

          if (getPredictedAgentResponse.agent) {
            _context20.next = 13;
            break;
          }

          return _context20.abrupt("return", payload.promise.resolve({}));

        case 13:
          _context20.next = 15;
          return call(getTranslations);

        case 15:
          translations = _context20.sent;
          _getPredictedAgentRes = getPredictedAgentResponse.agent, login = _getPredictedAgentRes.login, name = _getPredictedAgentRes.name, avatarUrl = _getPredictedAgentRes.avatar_url, jobTitle = _getPredictedAgentRes.job_title, isBot = _getPredictedAgentRes.is_bot;
          welcomeMesssage = translations.welcome_to_chat;
          _context20.next = 20;
          return put(propsActions.setPropertyWelcomeMessage(welcomeMesssage));

        case 20:
          agent = {
            name: name,
            isBot: isBot,
            jobTitle: jobTitle,
            id: login,
            avatarUrl: parseUrlToCdn(avatarUrl),
            message: welcomeMesssage
          };
          return _context20.abrupt("return", payload.promise.resolve(agent));

        case 24:
          _context20.prev = 24;
          _context20.t0 = _context20["catch"](1);
          return _context20.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 27:
        case "end":
          return _context20.stop();
      }
    }
  }, _marked20, null, [[1, 24]]);
}

function getPostChatFormHandler(_ref13) {
  var payload, postChatFormResponse, parsedJsonResponse, postChatForm;
  return _regeneratorRuntime.wrap(function getPostChatFormHandler$(_context21) {
    while (1) {
      switch (_context21.prev = _context21.next) {
        case 0:
          payload = _ref13.payload;
          _context21.prev = 1;
          _context21.next = 4;
          return call(getPostChat);

        case 4:
          postChatFormResponse = _context21.sent;
          parsedJsonResponse = parseJson(postChatFormResponse[1]);

          if (parsedJsonResponse.survey) {
            _context21.next = 8;
            break;
          }

          return _context21.abrupt("return", payload.promise.reject({
            type: 'state',
            reason: 'Post-chat survey is turned off'
          }));

        case 8:
          postChatForm = translateForm(parsedJsonResponse.survey);
          _context21.next = 11;
          return put(propsActions.setPropertyPostChatForm(postChatForm));

        case 11:
          return _context21.abrupt("return", payload.promise.resolve(postChatForm));

        case 14:
          _context21.prev = 14;
          _context21.t0 = _context21["catch"](1);
          return _context21.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 17:
        case "end":
          return _context21.stop();
      }
    }
  }, _marked21, null, [[1, 14]]);
}

function sendPostChatFormHandler(_ref14) {
  var payload, answers, postChatForm, translatedAnswers;
  return _regeneratorRuntime.wrap(function sendPostChatFormHandler$(_context22) {
    while (1) {
      switch (_context22.prev = _context22.next) {
        case 0:
          payload = _ref14.payload;
          _context22.prev = 1;
          answers = payload.answers;
          _context22.next = 5;
          return select(propsSelectors.getPropertyPostChatForm);

        case 5:
          postChatForm = _context22.sent;
          translatedAnswers = translateFormAnswers(answers, postChatForm);
          _context22.next = 9;
          return call(sendPostChat, {
            answers: translatedAnswers
          });

        case 9:
          return _context22.abrupt("return", payload.promise.resolve({
            success: true
          }));

        case 12:
          _context22.prev = 12;
          _context22.t0 = _context22["catch"](1);
          return _context22.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 15:
        case "end":
          return _context22.stop();
      }
    }
  }, _marked22, null, [[1, 12]]);
}

function getConfigHandler(_ref15) {
  var payload, config;
  return _regeneratorRuntime.wrap(function getConfigHandler$(_context23) {
    while (1) {
      switch (_context23.prev = _context23.next) {
        case 0:
          payload = _ref15.payload;
          _context23.next = 3;
          return select(propsSelectors.getPropertyConfig);

        case 3:
          config = _context23.sent;

          if (config) {
            _context23.next = 7;
            break;
          }

          _context23.next = 7;
          return call(fetchStaticConfig);

        case 7:
          _context23.next = 9;
          return select(propsSelectors.getPropertyConfig);

        case 9:
          config = _context23.sent;
          payload.promise.resolve(config);

        case 11:
        case "end":
          return _context23.stop();
      }
    }
  }, _marked23);
}

function acceptInvitationHandler(_ref16) {
  var payload;
  return _regeneratorRuntime.wrap(function acceptInvitationHandler$(_context24) {
    while (1) {
      switch (_context24.prev = _context24.next) {
        case 0:
          payload = _ref16.payload;
          _context24.next = 3;
          return put(propsActions.setPropertyAcceptedInvitation(payload.id));

        case 3:
          payload.promise.resolve({
            success: true
          });

        case 4:
        case "end":
          return _context24.stop();
      }
    }
  }, _marked24);
}

function markMessageAsSeenHandler(_ref17) {
  var payload, messageId;
  return _regeneratorRuntime.wrap(function markMessageAsSeenHandler$(_context25) {
    while (1) {
      switch (_context25.prev = _context25.next) {
        case 0:
          payload = _ref17.payload;
          _context25.prev = 1;
          messageId = payload.messageId;
          _context25.next = 5;
          return call(markMessageAsSeen, {
            messageId: messageId
          });

        case 5:
          return _context25.abrupt("return", payload.promise.resolve({
            success: true
          }));

        case 8:
          _context25.prev = 8;
          _context25.t0 = _context25["catch"](1);
          return _context25.abrupt("return", payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          }));

        case 11:
        case "end":
          return _context25.stop();
      }
    }
  }, _marked25, null, [[1, 8]]);
}

function startChatHandler(_ref18) {
  var payload, chatState, chatting, welcomeMessage, chatId;
  return _regeneratorRuntime.wrap(function startChatHandler$(_context26) {
    while (1) {
      switch (_context26.prev = _context26.next) {
        case 0:
          payload = _ref18.payload;
          _context26.next = 3;
          return call(waitForState, propsSelectors.getPropertyChatState);

        case 3:
          chatState = _context26.sent;
          chatting = chatState === CHATTING;

          if (!chatting) {
            _context26.next = 8;
            break;
          }

          payload.promise.reject({
            type: 'state',
            reason: "You can't start new chat during chat"
          });
          return _context26.abrupt("return");

        case 8:
          _context26.next = 10;
          return select(propsSelectors.getPropertyWelcomeMessage);

        case 10:
          welcomeMessage = _context26.sent;

          if (welcomeMessage) {
            _context26.next = 15;
            break;
          }

          _context26.next = 14;
          return call(getTranslations);

        case 14:
          welcomeMessage = _context26.sent.welcome_to_chat;

        case 15:
          _context26.prev = 15;
          _context26.next = 18;
          return call(startChat, {
            customId: 'startchat',
            welcomeMessage: welcomeMessage
          });

        case 18:
          _context26.next = 20;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 20:
          chatId = _context26.sent;
          payload.promise.resolve({
            chatId: chatId
          });
          _context26.next = 27;
          break;

        case 24:
          _context26.prev = 24;
          _context26.t0 = _context26["catch"](15);
          payload.promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });

        case 27:
        case "end":
          return _context26.stop();
      }
    }
  }, _marked26, null, [[15, 24]]);
}

function checkGroupStatusHandler(_ref19) {
  var payload, group, promise, checkGroup, clientLimitExceeded, chatState, chatting, chatStatus, statusPingResponse, _parseResponseToChatS, _chatStatus, _chatState;

  return _regeneratorRuntime.wrap(function checkGroupStatusHandler$(_context27) {
    while (1) {
      switch (_context27.prev = _context27.next) {
        case 0:
          payload = _ref19.payload;
          group = payload.group, promise = payload.promise;

          if (!(typeof group !== 'undefined')) {
            _context27.next = 6;
            break;
          }

          _context27.t0 = group;
          _context27.next = 9;
          break;

        case 6:
          _context27.next = 8;
          return select(propsSelectors.getPropertyGroup);

        case 8:
          _context27.t0 = _context27.sent;

        case 9:
          checkGroup = _context27.t0;
          _context27.next = 12;
          return select(propsSelectors.getPropertyClientLimitExceeded);

        case 12:
          clientLimitExceeded = _context27.sent;

          if (!(!clientLimitExceeded && typeof group === 'undefined')) {
            _context27.next = 23;
            break;
          }

          _context27.next = 16;
          return select(propsSelectors.getPropertyChatState);

        case 16:
          chatState = _context27.sent;
          chatting = chatState === CHATTING;
          _context27.next = 20;
          return select(propsSelectors.getPropertyChatStatus);

        case 20:
          chatStatus = _context27.sent;
          promise.resolve({
            groupStatus: chatStatus.toLowerCase(),
            chatting: chatting
          });
          return _context27.abrupt("return");

        case 23:
          _context27.prev = 23;
          _context27.next = 26;
          return call(statusPing, checkGroup);

        case 26:
          statusPingResponse = _context27.sent;
          _parseResponseToChatS = parseResponseToChatStatus(statusPingResponse), _chatStatus = _parseResponseToChatS.chatStatus, _chatState = _parseResponseToChatS.chatState;

          if (!(clientLimitExceeded && _chatState === CHATTING)) {
            _context27.next = 31;
            break;
          }

          _context27.next = 31;
          return put(propsActions.setPropertyClientLimitExceeded(false));

        case 31:
          promise.resolve({
            groupStatus: _chatStatus.toLowerCase(),
            chatting: _chatState === CHATTING
          });
          _context27.next = 37;
          break;

        case 34:
          _context27.prev = 34;
          _context27.t1 = _context27["catch"](23);
          promise.reject({
            type: 'connection',
            reason: 'Request failed'
          });

        case 37:
        case "end":
          return _context27.stop();
      }
    }
  }, _marked27, null, [[23, 34]]);
}

function oldVisitorPingerStopper() {
  var chatState, chatting;
  return _regeneratorRuntime.wrap(function oldVisitorPingerStopper$(_context28) {
    while (1) {
      switch (_context28.prev = _context28.next) {
        case 0:

          _context28.next = 3;
          return call(delay, PING_MAXIMUM_TIME_ON_PAGE);

        case 3:
          _context28.next = 5;
          return select(propsSelectors.getPropertyChatState);

        case 5:
          chatState = _context28.sent;
          chatting = chatState === CHATTING;

          if (chatting) {
            _context28.next = 10;
            break;
          }

          _context28.next = 10;
          return put(propsActions.setPropertyClientLimitExceeded(true));

        case 10:
          _context28.next = 0;
          break;

        case 12:
        case "end":
          return _context28.stop();
      }
    }
  }, _marked28);
}

function setVisitorDataTask() {
  var channel, action;
  return _regeneratorRuntime.wrap(function setVisitorDataTask$(_context29) {
    while (1) {
      switch (_context29.prev = _context29.next) {
        case 0:
          _context29.next = 2;
          return actionChannel([publicSetVisitorData$1.getActionName()], buffers.expanding());

        case 2:
          channel = _context29.sent;
          _context29.next = 5;
          return take('VISITOR_DATA_WATCHER');

        case 5:

          _context29.next = 8;
          return take(channel);

        case 8:
          action = _context29.sent;
          _context29.next = 11;
          return call(waitForState, propsSelectors.getPropertyPingSent);

        case 11:
          _context29.next = 13;
          return call(setVisitorDataHandler, action);

        case 13:
          _context29.next = 5;
          break;

        case 15:
        case "end":
          return _context29.stop();
      }
    }
  }, _marked29);
}

function setVisitorGroupHandler(_ref20) {
  var payload;
  return _regeneratorRuntime.wrap(function setVisitorGroupHandler$(_context30) {
    while (1) {
      switch (_context30.prev = _context30.next) {
        case 0:
          payload = _ref20.payload;
          _context30.next = 3;
          return put(propsActions.setPropertyGroup(payload.group));

        case 3:
        case "end":
          return _context30.stop();
      }
    }
  }, _marked30);
}

function _callee$1() {
  var queuedActionsChannel, _loop, _ret;

  return _regeneratorRuntime.wrap(function _callee$(_context32) {
    while (1) {
      switch (_context32.prev = _context32.next) {
        case 0:
          _context32.next = 2;
          return fork(oldVisitorPingerStopper);

        case 2:
          _context32.next = 4;
          return fork(setVisitorDataTask);

        case 4:
          _context32.next = 6;
          return takeEvery(publicAcceptInvitation$1.getActionName(), acceptInvitationHandler);

        case 6:
          _context32.next = 8;
          return takeEvery(publicGetTranslations$1.getActionName(), getTranslationsHandler);

        case 8:
          _context32.next = 10;
          return takeEvery(publicGetTicketForm$1.getActionName(), getTicketFormHandler);

        case 10:
          _context32.next = 12;
          return takeEvery(publicGetQueueForm$1.getActionName(), getQueueFormHandler);

        case 12:
          _context32.next = 14;
          return takeEvery(publicSendTicketForm$1.getActionName(), sendTicketFormHandler);

        case 14:
          _context32.next = 16;
          return takeEvery(publicRateChat$1.getActionName(), rateChatHandler);

        case 16:
          _context32.next = 18;
          return takeEvery(publicSetSneakPeek$1.getActionName(), setSneakPeekHandler);

        case 18:
          _context32.next = 20;
          return takeEvery(publicCloseChat$1.getActionName(), closeChatHandler);

        case 20:
          _context32.next = 22;
          return takeEvery(publicForwardChatTranscript$1.getActionName(), forwardChatTranscriptHandler);

        case 22:
          _context32.next = 24;
          return takeEvery(publicDisconnect$1.getActionName(), disconnectHandler);

        case 24:
          _context32.next = 26;
          return takeEvery(publicGetVisitorData$1.getActionName(), getVisitorDataHandler);

        case 26:
          _context32.next = 28;
          return takeEvery(publicGetPrechatForm$1.getActionName(), getPreChatFormHandler);

        case 28:
          _context32.next = 30;
          return takeEvery(publicGetPredictedAgent$1.getActionName(), getPredictedAgentHandler);

        case 30:
          _context32.next = 32;
          return takeEvery(publicGetPostChatForm$1.getActionName(), getPostChatFormHandler);

        case 32:
          _context32.next = 34;
          return takeEvery(publicSendPostChatForm$1.getActionName(), sendPostChatFormHandler);

        case 34:
          _context32.next = 36;
          return takeEvery(publicGetConfig$1.getActionName(), getConfigHandler);

        case 36:
          _context32.next = 38;
          return takeEvery(publicMarkMessageAsSeen$1.getActionName(), markMessageAsSeenHandler);

        case 38:
          _context32.next = 40;
          return takeEvery(publicCheckGroupStatus$1.getActionName(), checkGroupStatusHandler);

        case 40:
          _context32.next = 42;
          return takeEvery(publicSetVisitorGroup$1.getActionName(), setVisitorGroupHandler);

        case 42:
          _context32.next = 44;
          return actionChannel([publicSendMessage$1.getActionName(), publicSendFile$1.getActionName(), publicSendPrechatForm$1.getActionName(), publicStartChat$1.getActionName()], buffers.expanding());

        case 44:
          queuedActionsChannel = _context32.sent;
          _loop =
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _loop() {
            var action, task, response;
            return _regeneratorRuntime.wrap(function _loop$(_context31) {
              while (1) {
                switch (_context31.prev = _context31.next) {
                  case 0:
                    _context31.next = 2;
                    return take(queuedActionsChannel);

                  case 2:
                    action = _context31.sent;
                    _context31.t0 = action.type;
                    _context31.next = _context31.t0 === publicSendMessage$1.getActionName() ? 6 : _context31.t0 === publicSendFile$1.getActionName() ? 9 : _context31.t0 === publicSendPrechatForm$1.getActionName() ? 19 : _context31.t0 === publicStartChat$1.getActionName() ? 22 : 25;
                    break;

                  case 6:
                    _context31.next = 8;
                    return call(sendMessageHandler, action);

                  case 8:
                    return _context31.abrupt("break", 26);

                  case 9:
                    _context31.next = 11;
                    return fork(sendFileHandler, action);

                  case 11:
                    task = _context31.sent;
                    _context31.next = 14;
                    return race({
                      success: join(task),
                      cancel: take(function (anyAction) {
                        return anyAction.type === publicCancelSendFile.getActionName() && anyAction.payload.customId === action.payload.customId;
                      })
                    });

                  case 14:
                    response = _context31.sent;

                    if (!response.cancel) {
                      _context31.next = 18;
                      break;
                    }

                    _context31.next = 18;
                    return cancel(task);

                  case 18:
                    return _context31.abrupt("break", 26);

                  case 19:
                    _context31.next = 21;
                    return call(sendPreChatFormHandler, action);

                  case 21:
                    return _context31.abrupt("break", 26);

                  case 22:
                    _context31.next = 24;
                    return call(startChatHandler, action);

                  case 24:
                    return _context31.abrupt("break", 26);

                  case 25:
                    return _context31.abrupt("return", {
                      v: void 0
                    });

                  case 26:
                  case "end":
                    return _context31.stop();
                }
              }
            }, _loop);
          });

        case 46:

          return _context32.delegateYield(_loop(), "t0", 48);

        case 48:
          _ret = _context32.t0;

          if (!(typeof _ret === "object")) {
            _context32.next = 51;
            break;
          }

          return _context32.abrupt("return", _ret.v);

        case 51:
          _context32.next = 46;
          break;

        case 53:
        case "end":
          return _context32.stop();
      }
    }
  }, _marked31);
}

var _marked$j =
/*#__PURE__*/
_regeneratorRuntime.mark(startChat);
function startChat(_ref) {
  var customId, text, answers, welcomeMessage, acceptedInvitation, _ref$fromManualInvita, fromManualInvitation, group, visitorId, visitorData, visitorName, mobile, startChatBody, license, startChatResponse;

  return _regeneratorRuntime.wrap(function startChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          customId = _ref.customId, text = _ref.text, answers = _ref.answers, welcomeMessage = _ref.welcomeMessage, acceptedInvitation = _ref.acceptedInvitation, _ref$fromManualInvita = _ref.fromManualInvitation, fromManualInvitation = _ref$fromManualInvita === void 0 ? false : _ref$fromManualInvita;
          _context.next = 3;
          return select(propsSelectors.getPropertyGroup);

        case 3:
          group = _context.sent;
          _context.next = 6;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 6:
          visitorId = _context.sent;
          _context.next = 9;
          return select(getVisitorData);

        case 9:
          visitorData = _context.sent;
          _context.t1 = visitorData.name;

          if (_context.t1) {
            _context.next = 15;
            break;
          }

          _context.next = 14;
          return call(getTranslations);

        case 14:
          _context.t1 = _context.sent.client;

        case 15:
          _context.t0 = _context.t1;

          if (_context.t0) {
            _context.next = 18;
            break;
          }

          _context.t0 = 'Client';

        case 18:
          visitorName = _context.t0;
          _context.next = 21;
          return select(propsSelectors.getPropertyMobile);

        case 21:
          mobile = _context.sent;
          _context.next = 24;
          return call(waitForState, propsSelectors.getPropertyPingSent);

        case 24:
          startChatBody = {
            group: group,
            source_group: group,
            details: '',
            details_labels: '',
            from_manual_invitation: fromManualInvitation,
            integration_params: '',
            random_id: customId,
            trigger_unique_id: '',
            version: 'Embedded',
            custom_variables: {},
            is_mobile: mobile,
            welcome_message: (welcomeMessage || '').replace(/%name%/g, visitorName),
            return_secured_session_id: true,
            visitor: {
              id: visitorId,
              nick: visitorName,
              email: visitorData.email || ''
            },
            script_version: {
              embedded_env: process.env.NODE_ENV,
              embedded_version: 'VisitorSDK-' + "0.36.2"
            }
          };

          if (text) {
            startChatBody.visitor_message = text;
            startChatBody.visitor_message_id = customId;
          }

          if (visitorData.customProperties) {
            startChatBody.custom_variables = mapValues(String, visitorData.customProperties);
          }

          if (answers) {
            startChatBody.pre_chat_survey = answers;
          }

          if (acceptedInvitation) {
            startChatBody.trigger_unique_id = acceptedInvitation;
          }

          _context.next = 31;
          return put(propsActions.setPropertyChatId(undefined));

        case 31:
          _context.next = 33;
          return select(propsSelectors.getPropertyLicense);

        case 33:
          license = _context.sent;
          storage$1.removeItem('securedToken');
          storage$1.removeOldSecretTokenCookie(license);
          _context.next = 38;
          return put(propsActions.removePropertySecuredToken());

        case 38:
          _context.next = 40;
          return put(propsActions.setPropertyServerIdsMap({}));

        case 40:
          _context.next = 42;
          return put(propsActions.setPropertyVisitorCustomIdMap({}));

        case 42:
          _context.next = 44;
          return call(sendJsonRequest, 'start_chat', startChatBody);

        case 44:
          startChatResponse = _context.sent;

          if (!startChatResponse.secured_session_id) {
            _context.next = 49;
            break;
          }

          _context.next = 48;
          return put(propsActions.setPropertySecretId(startChatResponse.secured_session_id));

        case 48:
          storage$1.setItem('secretId', startChatResponse.secured_session_id);

        case 49:
          if (!startChatResponse.secured_token) {
            _context.next = 55;
            break;
          }

          _context.next = 52;
          return put(propsActions.setPropertySecuredToken(startChatResponse.secured_token));

        case 52:
          _context.next = 54;
          return put(propsActions.setPropertyChatState(CHATTING));

        case 54:
          storage$1.setItem('securedToken', startChatResponse.secured_token);

        case 55:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$j);
}

var _marked$k =
/*#__PURE__*/
_regeneratorRuntime.mark(sendPingRequest),
    _marked2$4 =
/*#__PURE__*/
_regeneratorRuntime.mark(parsePingResponse),
    _marked3$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchSetVisitorActions),
    _marked4$3 =
/*#__PURE__*/
_regeneratorRuntime.mark(startPing),
    _marked5$3 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee$2);

var prepareRequestBody = function prepareRequestBody(sendAllDetails, visitorId, group, visitorData) {
  var requestBody = {
    visitor: {
      id: visitorId,
      group: group
    }
  };

  if (sendAllDetails) {
    requestBody.page = {
      title: visitorData.pageTitle,
      url: visitorData.pageUrl
    };
  }

  if (sendAllDetails && visitorData.pageReferrer) {
    requestBody.page.referrer = visitorData.pageReferrer;
  }

  if (sendAllDetails && visitorData.email) {
    requestBody.visitor.email = visitorData.email;
  }

  if (sendAllDetails && visitorData.name) {
    requestBody.visitor.name = visitorData.name;
  }

  if (sendAllDetails && visitorData.customProperties) {
    requestBody.visitor.custom_variables = parseCustomVariables(visitorData.customProperties);
  }

  return requestBody;
};

function sendPingRequest(_ref) {
  var sendFullPing, visitorId, license, group, visitorData, environment, region, requestBody, chatBetweenGroups, requestDistribution, pingResponse, connectionStatus, _connectionStatus;

  return _regeneratorRuntime.wrap(function sendPingRequest$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          sendFullPing = _ref.sendFullPing;
          _context.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context.sent;
          _context.next = 6;
          return select(propsSelectors.getPropertyLicense);

        case 6:
          license = _context.sent;
          _context.next = 9;
          return select(propsSelectors.getPropertyGroup);

        case 9:
          group = _context.sent;
          _context.next = 12;
          return select(getVisitorData);

        case 12:
          visitorData = _context.sent;
          _context.next = 15;
          return select(getEnvironment);

        case 15:
          environment = _context.sent;
          _context.next = 18;
          return select(propsSelectors.getPropertyRegion);

        case 18:
          region = _context.sent;
          requestBody = prepareRequestBody(sendFullPing, visitorId, group, visitorData);
          _context.next = 22;
          return select(propsSelectors.getPropertyChatBetweenGroups);

        case 22:
          chatBetweenGroups = _context.sent;
          _context.next = 25;
          return select(propsSelectors.getPropertyRequestDistribution);

        case 25:
          requestDistribution = _context.sent;
          _context.prev = 26;
          _context.t0 = call;
          _context.t1 = sendPostToWebserv;
          _context.t2 = license;
          _context.t3 = environment;
          _context.t4 = region;
          _context.t5 = requestBody;
          _context.next = 35;
          return getContext('external');

        case 35:
          _context.t6 = _context.sent;
          _context.t7 = chatBetweenGroups;
          _context.t8 = group;
          _context.t9 = requestDistribution;
          _context.t10 = {
            license: _context.t2,
            environment: _context.t3,
            region: _context.t4,
            body: _context.t5,
            external: _context.t6,
            chatBetweenGroups: _context.t7,
            group: _context.t8,
            requestDistribution: _context.t9
          };
          _context.t11 = {
            retry: 10
          };
          _context.next = 43;
          return (0, _context.t0)(_context.t1, 'ping', _context.t10, _context.t11);

        case 43:
          pingResponse = _context.sent;
          _context.next = 46;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 46:
          connectionStatus = _context.sent;

          if (!(connectionStatus !== 'connected')) {
            _context.next = 50;
            break;
          }

          _context.next = 50;
          return put(propsActions.setPropertyConnectionStatus('connected'));

        case 50:
          return _context.abrupt("return", pingResponse);

        case 53:
          _context.prev = 53;
          _context.t12 = _context["catch"](26);
          _context.next = 57;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 57:
          _connectionStatus = _context.sent;

          if (!(_connectionStatus !== 'disconnected')) {
            _context.next = 61;
            break;
          }

          _context.next = 61;
          return put(propsActions.setPropertyConnectionStatus('disconnected'));

        case 61:
          return _context.abrupt("return", {
            error: true
          });

        case 62:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$k, null, [[26, 53]]);
}

function parsePingResponse(pingResponse) {
  var _parseInvitation, agent, invitation, translations, welcomeMessage;

  return _regeneratorRuntime.wrap(function parsePingResponse$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if (!pingResponse.automatic_greeting) {
            _context2.next = 8;
            break;
          }

          _parseInvitation = parseInvitation(pingResponse.automatic_greeting), agent = _parseInvitation.agent, invitation = _parseInvitation.invitation;
          _context2.next = 4;
          return put(newAgent(_extends({}, agent, {
            fromInvitation: true
          })));

        case 4:
          _context2.next = 6;
          return put(newInvitation(invitation));

        case 6:
          _context2.next = 20;
          break;

        case 8:
          if (!pingResponse.personal_greeting) {
            _context2.next = 13;
            break;
          }

          _context2.next = 11;
          return call(startChat, {
            customId: String(Math.random()),
            welcomeMessage: pingResponse.personal_greeting.greeting_message.message,
            fromManualInvitation: true
          });

        case 11:
          _context2.next = 20;
          break;

        case 13:
          if (!pingResponse.standard_greeting) {
            _context2.next = 20;
            break;
          }

          _context2.next = 16;
          return call(getTranslations);

        case 16:
          translations = _context2.sent;
          welcomeMessage = translations.welcome_to_chat;
          _context2.next = 20;
          return call(startChat, {
            customId: String(Math.random()),
            welcomeMessage: welcomeMessage,
            fromManualInvitation: true
          });

        case 20:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$4);
}

function watchSetVisitorActions() {
  var setVisitorDataActionChannel, action, requestResponse, visitorData;
  return _regeneratorRuntime.wrap(function watchSetVisitorActions$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return actionChannel(setVisitorData.getActionName(), buffers.expanding());

        case 2:
          setVisitorDataActionChannel = _context3.sent;
          _context3.next = 5;
          return put({
            type: 'VISITOR_DATA_WATCHER'
          });

        case 5:

          _context3.next = 8;
          return take(setVisitorDataActionChannel);

        case 8:
          action = _context3.sent;

          if (action.payload.internal) {
            _context3.next = 26;
            break;
          }

          _context3.next = 12;
          return call(sendPingRequest, {
            sendFullPing: true
          });

        case 12:
          requestResponse = _context3.sent;

          if (!requestResponse.error) {
            _context3.next = 17;
            break;
          }

          _context3.next = 16;
          return put(visitorDataSetError({
            error: requestResponse.error,
            requestId: action.payload.requestId
          }));

        case 16:
          return _context3.abrupt("return", _context3.sent);

        case 17:
          _context3.next = 19;
          return call(parsePingResponse, requestResponse);

        case 19:
          _context3.next = 21;
          return select(getVisitorData);

        case 21:
          visitorData = _context3.sent;
          _context3.next = 24;
          return put(visitorDataSet({
            visitorData: visitorData,
            requestId: action.payload.requestId
          }));

        case 24:
          _context3.next = 34;
          break;

        case 26:
          _context3.t0 = put;
          _context3.next = 29;
          return select(getVisitorData);

        case 29:
          _context3.t1 = _context3.sent;
          _context3.t2 = {
            visitorData: _context3.t1
          };
          _context3.t3 = {
            type: 'EMIT_VISITOR_DATA',
            payload: _context3.t2
          };
          _context3.next = 34;
          return (0, _context3.t0)(_context3.t3);

        case 34:
          _context3.next = 5;
          break;

        case 36:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$2);
}

function startPing() {
  var nextPing, sendFullPing, pingResponse, lastSendFullPing;
  return _regeneratorRuntime.wrap(function startPing$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          nextPing = 3;
          sendFullPing = true;
          _context4.next = 4;
          return call(waitForState, propsSelectors.getPropertyRequestDistribution);

        case 4:

          _context4.next = 7;
          return call(sendPingRequest, {
            sendFullPing: sendFullPing
          });

        case 7:
          pingResponse = _context4.sent;
          lastSendFullPing = sendFullPing;
          sendFullPing = Boolean(pingResponse.next_ping_send_full_details);

          if (!(pingResponse.next_ping_delay === 0)) {
            _context4.next = 16;
            break;
          }

          _context4.next = 13;
          return call(checkProtocolVersion);

        case 13:
          _context4.next = 15;
          return put(propsActions.setPropertyClientLimitExceeded(true));

        case 15:
          return _context4.abrupt("return");

        case 16:
          if (!lastSendFullPing && sendFullPing) {
            nextPing = 0;
          } else {
            nextPing = pingResponse.next_ping_delay || 3;
          }

          _context4.next = 19;
          return call(parsePingResponse, pingResponse);

        case 19:
          _context4.next = 21;
          return put(propsActions.setPropertyPingSent(true));

        case 21:
          _context4.next = 23;
          return call(delay, nextPing * 1000);

        case 23:
          _context4.next = 4;
          break;

        case 25:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$3);
} // export default sendPing


function _callee$2() {
  return _regeneratorRuntime.wrap(function _callee$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return fork(startPing);

        case 2:
          _context5.next = 4;
          return fork(watchSetVisitorActions);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$3);
}

var _marked$l =
/*#__PURE__*/
_regeneratorRuntime.mark(sendPing);

function sendPing() {
  var license, statusPingResponse, chatStatus, chatState, _parseResponseToChatS, currentChatStatus, currentChatState, connectionStatus, securedToken, _connectionStatus;

  return _regeneratorRuntime.wrap(function sendPing$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return call(waitForState, propsSelectors.getPropertyRequestDistribution);

        case 2:

          _context.next = 5;
          return select(propsSelectors.getPropertyLicense);

        case 5:
          license = _context.sent;
          _context.prev = 6;
          _context.next = 9;
          return call(statusPing);

        case 9:
          statusPingResponse = _context.sent;
          _context.next = 12;
          return select(propsSelectors.getPropertyChatStatus);

        case 12:
          chatStatus = _context.sent;
          _context.next = 15;
          return select(propsSelectors.getPropertyChatState);

        case 15:
          chatState = _context.sent;
          _parseResponseToChatS = parseResponseToChatStatus(statusPingResponse), currentChatStatus = _parseResponseToChatS.chatStatus, currentChatState = _parseResponseToChatS.chatState;
          _context.next = 19;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 19:
          connectionStatus = _context.sent;

          if (!(connectionStatus !== 'connected')) {
            _context.next = 23;
            break;
          }

          _context.next = 23;
          return put(propsActions.setPropertyConnectionStatus('connected'));

        case 23:
          if (!(chatStatus !== currentChatStatus)) {
            _context.next = 26;
            break;
          }

          _context.next = 26;
          return put(propsActions.setPropertyChatStatus(currentChatStatus));

        case 26:
          if (!(chatState !== currentChatState && currentChatState === CHATTING)) {
            _context.next = 32;
            break;
          }

          securedToken = storage$1.getItem('securedToken') || get$1("secret_token_" + license);
          _context.next = 30;
          return put(propsActions.setPropertySecuredToken(securedToken));

        case 30:
          _context.next = 32;
          return put(propsActions.setPropertyChatState(currentChatState));

        case 32:
          _context.next = 42;
          break;

        case 34:
          _context.prev = 34;
          _context.t0 = _context["catch"](6);
          _context.next = 38;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 38:
          _connectionStatus = _context.sent;

          if (!(_connectionStatus !== 'disconnected')) {
            _context.next = 42;
            break;
          }

          _context.next = 42;
          return put(propsActions.setPropertyConnectionStatus('disconnected'));

        case 42:
          _context.next = 44;
          return call(delay, 3000);

        case 44:
          _context.next = 2;
          break;

        case 46:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$l, null, [[6, 34]]);
}

var CHAT_STARTED$1 = 'chat_started';
var NEW_MESSAGE$1 = 'new_message';
var CHAT_ENDED$1 = 'chat_ended';
var AGENT_CHANGED = 'agent_changed';
var STATUS_CHANGED = 'status_changed';
var CONNECTION_STATUS_CHANGED = 'connection_status_changed';
var NEW_FILE$1 = 'new_file';
var VISITOR_QUEUED$1 = 'visitor_queued';
var TYPING_INDICATOR$1 = 'typing_indicator';
var VISITOR_DATA = 'visitor_data';
var CHAT_RATED = 'chat_rated';
var NEW_INVITATION$1 = 'new_invitation';
var READY = 'ready';
var MESSAGE_SEEN$1 = 'message_seen';
var PROTOCOL_UPGRADED$1 = 'protocol_upgraded';
var INTEGRATION_DATA$1 = 'integration_data';

var _marked$m =
/*#__PURE__*/
_regeneratorRuntime.mark(startChatWatcher),
    _marked2$5 =
/*#__PURE__*/
_regeneratorRuntime.mark(newMessageWatcher),
    _marked3$3 =
/*#__PURE__*/
_regeneratorRuntime.mark(newFileWatcher),
    _marked4$4 =
/*#__PURE__*/
_regeneratorRuntime.mark(newAgentWatcher),
    _marked5$4 =
/*#__PURE__*/
_regeneratorRuntime.mark(visitorIdWatcher),
    _marked6$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(newInvitationWatcher),
    _marked7$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(safeHandler),
    _marked8$2 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee$3);

function startChatWatcher(_ref, _ref2) {
  var emitter, payload, chatId, lastAgentId, serverIdsMap, _ref3, reason;

  return _regeneratorRuntime.wrap(function startChatWatcher$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          emitter = _ref.emitter;
          payload = _ref2.payload;
          emitter.emit('__start_chat_request_succeeded');
          _context.next = 5;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 5:
          chatId = _context.sent;
          emitter.emit(CHAT_STARTED$1, {
            chatId: chatId
          });

          if (!payload.welcomeMessage) {
            _context.next = 18;
            break;
          }

          _context.next = 10;
          return select(propsSelectors.getPropertyLastAgentId);

        case 10:
          lastAgentId = _context.sent;
          _context.next = 13;
          return select(propsSelectors.getPropertyServerIdsMap);

        case 13:
          serverIdsMap = _context.sent;
          _context.next = 16;
          return put(propsActions.setPropertyServerIdsMap(_extends({}, serverIdsMap, {
            welcome_message: {
              serverId: 'welcome_message',
              authorId: lastAgentId
            }
          })));

        case 16:
          _context.next = 18;
          return put(newMessage({
            id: 'welcome_message',
            timestamp: Date.now(),
            authorType: 'agent',
            authorId: lastAgentId,
            text: payload.welcomeMessage,
            chatId: chatId,
            customId: 'welcome_message'
          }));

        case 18:
          if (!payload.visitorMessage) {
            _context.next = 21;
            break;
          }

          _context.next = 21;
          return put(newMessage(payload.visitorMessage));

        case 21:
          _context.next = 23;
          return take(chatEnded.getActionName());

        case 23:
          _ref3 = _context.sent;
          reason = _ref3.payload.reason;
          emitter.emit(CHAT_ENDED$1, {
            reason: reason
          });
          _context.next = 28;
          return put(propsActions.setPropertyLastMessageId(null));

        case 28:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$m);
}

function statusWatcher(_ref4, _ref5) {
  var emitter = _ref4.emitter;
  var payload = _ref5.payload;
  emitter.emit(STATUS_CHANGED, {
    status: payload.data.toLowerCase()
  });
}

function connectionStatusWatcher(_ref6, _ref7) {
  var emitter = _ref6.emitter;
  var payload = _ref7.payload;
  emitter.emit(CONNECTION_STATUS_CHANGED, {
    status: payload.data.toLowerCase()
  });
}

function newMessageWatcher(_ref8, _ref9) {
  var emitter, payload, chatId, visitorId, message;
  return _regeneratorRuntime.wrap(function newMessageWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          emitter = _ref8.emitter;
          payload = _ref9.payload;
          _context2.next = 4;
          return call(waitForState, propsSelectors.getPropertyChatId);

        case 4:
          chatId = _context2.sent;
          _context2.next = 7;
          return select(propsSelectors.getPropertyVisitorId);

        case 7:
          visitorId = _context2.sent;
          message = {
            id: payload.id,
            timestamp: payload.timestamp,
            authorId: payload.authorType === 'visitor' ? visitorId : payload.authorId,
            text: payload.text,
            chatId: chatId,
            json: payload.json
          };

          if (typeof payload.isMobile !== 'undefined') {
            message.isMobile = payload.isMobile;
          }

          if (typeof payload.customId !== 'undefined') {
            message.customId = payload.customId;
          }

          emitter.emit(NEW_MESSAGE$1, message);

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$5);
}

function newFileWatcher(_ref10, _ref11) {
  var emitter, payload, visitorId, message;
  return _regeneratorRuntime.wrap(function newFileWatcher$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          emitter = _ref10.emitter;
          payload = _ref11.payload;
          _context3.next = 4;
          return select(propsSelectors.getPropertyVisitorId);

        case 4:
          visitorId = _context3.sent;
          message = {
            id: payload.id,
            timestamp: payload.timestamp,
            authorId: payload.authorType === 'visitor' ? visitorId : payload.authorId,
            url: payload.url,
            contentType: payload.contentType,
            size: payload.size
          };

          if (payload.thumbnail) {
            message.thumbnail = payload.thumbnail;
          }

          emitter.emit(NEW_FILE$1, message);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$3);
}

function newAgentWatcher(_ref12, _ref13) {
  var emitter, payload, lastAgentId, agentData;
  return _regeneratorRuntime.wrap(function newAgentWatcher$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          emitter = _ref12.emitter;
          payload = _ref13.payload;
          lastAgentId = select(propsSelectors.getPropertyLastAgentId);

          if (!(lastAgentId === payload.id)) {
            _context4.next = 5;
            break;
          }

          return _context4.abrupt("return");

        case 5:
          _context4.next = 7;
          return put(propsActions.setPropertyLastAgentId(payload.id));

        case 7:
          agentData = {
            name: payload.name,
            id: payload.id
          };

          if (payload.avatarUrl) {
            agentData.avatarUrl = payload.avatarUrl;
          }

          if (payload.jobTitle) {
            agentData.jobTitle = payload.jobTitle;
          }

          if (payload.fromInvitation) {
            agentData.fromInvitation = payload.fromInvitation;
          }

          emitter.emit(AGENT_CHANGED, agentData);

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$4);
}

function visitorQueuedWatcher(_ref14, _ref15) {
  var emitter = _ref14.emitter;
  var payload = _ref15.payload;
  var numberInQueue = payload.numberInQueue,
      waitingTime = payload.waitingTime;
  emitter.emit(VISITOR_QUEUED$1, {
    numberInQueue: numberInQueue,
    waitingTime: waitingTime
  });
}

function typingIndicatorWatcher(_ref16, _ref17) {
  var emitter = _ref16.emitter;
  var payload = _ref17.payload;
  var authorId = payload.authorId,
      isTyping = payload.isTyping;
  emitter.emit(TYPING_INDICATOR$1, {
    authorId: authorId,
    isTyping: isTyping
  });
}

function visitorIdWatcher(_ref18) {
  var emitter, visitorId, visitorData, callbackData;
  return _regeneratorRuntime.wrap(function visitorIdWatcher$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          emitter = _ref18.emitter;
          _context5.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context5.sent;
          _context5.next = 6;
          return select(getVisitorData);

        case 6:
          visitorData = _context5.sent;
          callbackData = visitorData.name ? {
            id: visitorId,
            name: visitorData.name
          } : {
            id: visitorId
          };
          Promise.resolve().then(function () {
            emitter.emit(VISITOR_DATA, callbackData);
          });

        case 9:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$4);
}

function rateChatWatcher(_ref19, action) {
  var emitter = _ref19.emitter;
  emitter.emit(CHAT_RATED, {
    rate: action.payload.rate,
    comment: action.payload.comment
  });
}

function newInvitationWatcher(_ref20, action) {
  var emitter;
  return _regeneratorRuntime.wrap(function newInvitationWatcher$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          emitter = _ref20.emitter;
          emitter.emit(NEW_INVITATION$1, action.payload);
          _context6.next = 4;
          return take(function (newAction) {
            return newAction.type === publicAcceptInvitation.getActionName() && newAction.payload.id === action.payload.id;
          });

        case 4:
          _context6.next = 6;
          return put(propsActions.setPropertyWelcomeMessage(action.payload.text));

        case 6:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6$2);
}

function readyWatcher(_ref21) {
  var emitter = _ref21.emitter;
  emitter.emit(READY);
}

function seenWatcher(_ref22, _ref23) {
  var emitter = _ref22.emitter;
  var payload = _ref23.payload;
  emitter.emit(MESSAGE_SEEN$1, payload);
}

function safeHandler(handlers, emitter, action) {
  return _regeneratorRuntime.wrap(function safeHandler$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return call(handlers[action.type], {
            emitter: emitter
          }, action);

        case 3:
          _context7.next = 7;
          break;

        case 5:
          _context7.prev = 5;
          _context7.t0 = _context7["catch"](0);

        case 7:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7$2, null, [[0, 5]]);
}

function protocolUpgradedWatcher(_ref24) {
  var emitter = _ref24.emitter;
  emitter.emit(PROTOCOL_UPGRADED$1);
}

function integrationDataWatcher(_ref25, _ref26) {
  var emitter = _ref25.emitter;
  var payload = _ref26.payload;
  emitter.emit(INTEGRATION_DATA$1, payload);
}

function emitVisitorDataWatcher(_ref27, _ref28) {
  var emitter = _ref27.emitter;
  var visitorData = _ref28.payload.visitorData;
  emitter.emit(VISITOR_DATA, cloneDeep(visitorData));
}

function _callee$3(_ref29) {
  var _handlers;

  var emitter, handlers;
  return _regeneratorRuntime.wrap(function _callee$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          emitter = _ref29.emitter;
          _context8.next = 3;
          return fork(visitorIdWatcher, {
            emitter: emitter
          });

        case 3:
          handlers = (_handlers = {}, _handlers[chatStarted.getActionName()] = startChatWatcher, _handlers[propsActions.setPropertyChatStatus.getActionName()] = statusWatcher, _handlers[propsActions.setPropertyConnectionStatus.getActionName()] = connectionStatusWatcher, _handlers[newMessage.getActionName()] = newMessageWatcher, _handlers[newFile.getActionName()] = newFileWatcher, _handlers[newAgent.getActionName()] = newAgentWatcher, _handlers[visitorQueued.getActionName()] = visitorQueuedWatcher, _handlers[typingIndicator.getActionName()] = typingIndicatorWatcher, _handlers[rateChat.getActionName()] = rateChatWatcher, _handlers[newInvitation.getActionName()] = newInvitationWatcher, _handlers[propsActions.setPropertyHistoryLoaded.getActionName()] = readyWatcher, _handlers[messageSeen.getActionName()] = seenWatcher, _handlers[protocolUpgraded.getActionName()] = protocolUpgradedWatcher, _handlers[integrationData.getActionName()] = integrationDataWatcher, _handlers.EMIT_VISITOR_DATA = emitVisitorDataWatcher, _handlers);
          _context8.next = 6;
          return takeEvery(Object.keys(handlers), safeHandler, handlers, emitter);

        case 6:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8$2);
}

var INCOMING_MESSAGE = 'INCOMING_MESSAGE';
var incomingMessage = createActionCreator(INCOMING_MESSAGE, function (_ref) {
  var name = _ref.name,
      message = _ref.message;
  return {
    name: name,
    message: message
  };
});

var CHAT_PINGER_INTERVAL = 1800;

var _marked$n =
/*#__PURE__*/
_regeneratorRuntime.mark(getPendingMessages);
function getPendingMessages(payload) {
  var visitorId, group, lastUniqueId, _payload, sneakPeek, requestData;

  return _regeneratorRuntime.wrap(function getPendingMessages$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (payload === void 0) {
            payload = {};
          }

          _context.next = 3;
          return call(waitForState, propsSelectors.getPropertyVisitorId);

        case 3:
          visitorId = _context.sent;
          _context.next = 6;
          return select(propsSelectors.getPropertyGroup);

        case 6:
          group = _context.sent;
          _context.next = 9;
          return select(propsSelectors.getPropertyLastMessageId);

        case 9:
          lastUniqueId = _context.sent;
          _payload = payload, sneakPeek = _payload.sneakPeek;
          requestData = {
            random_id: String(Math.random()),
            visitor: {
              id: visitorId,
              group: group
            }
          };

          if (lastUniqueId) {
            requestData.last_unique_id = lastUniqueId;
          }

          if (typeof sneakPeek === 'string') {
            requestData.sneak_peek = sneakPeek;
          }

          _context.next = 16;
          return call(sendJsonRequest, 'get_pending_messages', requestData);

        case 16:
          return _context.abrupt("return", _context.sent);

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$n);
}

var _marked$o =
/*#__PURE__*/
_regeneratorRuntime.mark(closeChat$1),
    _marked2$6 =
/*#__PURE__*/
_regeneratorRuntime.mark(checkChatState),
    _marked3$4 =
/*#__PURE__*/
_regeneratorRuntime.mark(sendChatPing),
    _marked4$5 =
/*#__PURE__*/
_regeneratorRuntime.mark(watchChatStateChange),
    _marked5$5 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee$4);
var lastSneakPeek = '';

function closeChat$1() {
  var license;
  return _regeneratorRuntime.wrap(function closeChat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyLicense);

        case 2:
          license = _context.sent;
          _context.next = 5;
          return put(propsActions.setPropertyChatState(NOT_CHATTING));

        case 5:
          _context.next = 7;
          return put(propsActions.removePropertySecuredToken());

        case 7:
          _context.next = 9;
          return put(chatEnded());

        case 9:
          storage$1.removeItem('securedToken');
          storage$1.removeOldSecretTokenCookie(license);
          _context.next = 13;
          return put(propsActions.setPropertyServerIdsMap({}));

        case 13:
          _context.next = 15;
          return put(propsActions.setPropertyVisitorCustomIdMap({}));

        case 15:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$o);
}

var parseMessage = function parseMessage(message) {
  if (get('message.data', message)) {
    message.message.data = mapKeys(camelCase, message.message.data);
  }

  if (get('message.name', message)) {
    message.message.name = camelCase(message.message.name);
  }

  return _extends({
    timestamp: message.timestamp,
    uniqueId: message.unique_id
  }, message.message);
};

var findLastUniqueId = function findLastUniqueId(messages) {
  return Math.max.apply(Math, [0].concat(messages.map(function (message) {
    return message.unique_id;
  })));
};

var parseChatPingResponse = function parseChatPingResponse(response) {
  return response.messages.map(function (message) {
    if (message.message_iwcs) {
      var translatedMessage = translateIWCS(message.message_iwcs);

      if (!translatedMessage) {
        return false;
      }

      return {
        timestamp: message.timestamp,
        unique_id: message.unique_id,
        message: translatedMessage
      };
    }

    return message;
  }).filter(Boolean).map(parseMessage);
};

function checkChatState() {
  var securedToken, chatPingResponse, parsedChatPingResponse, lastMessageId, connectionStatus;
  return _regeneratorRuntime.wrap(function checkChatState$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return call(waitForState, propsSelectors.getPropertyConfigLoaded);

        case 2:
          _context2.next = 4;
          return select(propsSelectors.getPropertySecuredToken);

        case 4:
          securedToken = _context2.sent;

          if (!securedToken) {
            _context2.next = 36;
            break;
          }

          _context2.prev = 6;
          _context2.next = 9;
          return call(getPendingMessages);

        case 9:
          chatPingResponse = _context2.sent;

          if (!chatPingResponse.messages) {
            _context2.next = 22;
            break;
          }

          parsedChatPingResponse = parseChatPingResponse(chatPingResponse);
          _context2.next = 14;
          return all(parsedChatPingResponse.map(function (message) {
            return put(incomingMessage({
              name: message.name,
              message: message
            }));
          }));

        case 14:
          lastMessageId = findLastUniqueId(chatPingResponse.messages);

          if (!lastMessageId) {
            _context2.next = 18;
            break;
          }

          _context2.next = 18;
          return put(propsActions.setPropertyLastMessageId(lastMessageId));

        case 18:
          _context2.next = 20;
          return put(propsActions.setPropertyChatState(CHATTING));

        case 20:
          _context2.next = 24;
          break;

        case 22:
          _context2.next = 24;
          return call(closeChat$1);

        case 24:
          _context2.next = 34;
          break;

        case 26:
          _context2.prev = 26;
          _context2.t0 = _context2["catch"](6);
          _context2.next = 30;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 30:
          connectionStatus = _context2.sent;

          if (!(connectionStatus !== 'disconnected')) {
            _context2.next = 34;
            break;
          }

          _context2.next = 34;
          return put(propsActions.setPropertyConnectionStatus('disconnected'));

        case 34:
          _context2.next = 38;
          break;

        case 36:
          _context2.next = 38;
          return put(propsActions.setPropertyChatState(NOT_CHATTING));

        case 38:
          _context2.next = 40;
          return put(propsActions.setPropertyHistoryLoaded(true));

        case 40:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$6, null, [[6, 26]]);
}

function sendChatPing() {
  var securedToken, chatState, sneakPeek, chatPingResponse, connectionStatus, parsedChatPingResponse, lastMessageId, _connectionStatus;

  return _regeneratorRuntime.wrap(function sendChatPing$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:

          _context3.next = 3;
          return select(propsSelectors.getPropertySecuredToken);

        case 3:
          securedToken = _context3.sent;
          _context3.next = 6;
          return select(propsSelectors.getPropertyChatState);

        case 6:
          chatState = _context3.sent;
          _context3.next = 9;
          return select(propsSelectors.getPropertySneakPeek);

        case 9:
          sneakPeek = _context3.sent;

          if (!(securedToken && chatState === CHATTING)) {
            _context3.next = 43;
            break;
          }

          _context3.prev = 11;
          _context3.next = 14;
          return call(getPendingMessages, {
            sneakPeek: lastSneakPeek !== sneakPeek ? sneakPeek : null
          });

        case 14:
          chatPingResponse = _context3.sent;
          _context3.next = 17;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 17:
          connectionStatus = _context3.sent;

          if (!(connectionStatus !== 'connected')) {
            _context3.next = 21;
            break;
          }

          _context3.next = 21;
          return put(propsActions.setPropertyConnectionStatus('connected'));

        case 21:
          if (chatPingResponse.messages) {
            _context3.next = 26;
            break;
          }

          _context3.next = 24;
          return call(closeChat$1);

        case 24:
          _context3.next = 33;
          break;

        case 26:
          parsedChatPingResponse = parseChatPingResponse(chatPingResponse);
          lastMessageId = findLastUniqueId(chatPingResponse.messages);

          if (!lastMessageId) {
            _context3.next = 31;
            break;
          }

          _context3.next = 31;
          return put(propsActions.setPropertyLastMessageId(lastMessageId));

        case 31:
          _context3.next = 33;
          return all(parsedChatPingResponse.map(function (message) {
            return put(incomingMessage({
              name: message.name,
              message: message
            }));
          }));

        case 33:
          _context3.next = 43;
          break;

        case 35:
          _context3.prev = 35;
          _context3.t0 = _context3["catch"](11);
          _context3.next = 39;
          return select(propsSelectors.getPropertyConnectionStatus);

        case 39:
          _connectionStatus = _context3.sent;

          if (!(_connectionStatus !== 'disconnected')) {
            _context3.next = 43;
            break;
          }

          _context3.next = 43;
          return put(propsActions.setPropertyConnectionStatus('disconnected'));

        case 43:
          lastSneakPeek = sneakPeek;
          _context3.next = 46;
          return race([call(delay, CHAT_PINGER_INTERVAL), take(publicSendFile.getActionName()), take('PRIVATE_SEND_MESSAGE')]);

        case 46:
          _context3.next = 0;
          break;

        case 48:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$4, null, [[11, 35]]);
}

function watchChatStateChange() {
  return _regeneratorRuntime.wrap(function watchChatStateChange$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return call(waitForState, propsSelectors.getPropertyChatState);

        case 2:
          _context4.next = 4;
          return call(sendChatPing);

        case 4:
          _context4.next = 6;
          return takeEvery(propsActions.setPropertyChatState.getActionName(), sendChatPing);

        case 6:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4$5);
}

function _callee$4() {
  return _regeneratorRuntime.wrap(function _callee$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return call(checkChatState);

        case 2:
          _context5.next = 4;
          return spawn(watchChatStateChange);

        case 4:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5$5);
}

var AGENT_MESSAGE_SEEN = 'agentMessageSeen';
var SEND_MESSAGE = 'sendMessage';
var START_CHAT = 'startChat';
var CHAT_ATTACHMENT = 'chatAttachment';
var CHAT_COMMENT = 'sendRatingComment';
var VISITOR_MESSAGE_SEEN = 'visitorMessageSeen';

var _marked$p =
/*#__PURE__*/
_regeneratorRuntime.mark(addIdToVisitorCustomIdMap),
    _marked2$7 =
/*#__PURE__*/
_regeneratorRuntime.mark(parseIncomingServerMessage),
    _marked3$5 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee$5);

function addIdToVisitorCustomIdMap(randomId, uniqueId) {
  var _extends2;

  var _visitorCustomIdMap;

  return _regeneratorRuntime.wrap(function addIdToVisitorCustomIdMap$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return select(propsSelectors.getPropertyVisitorCustomIdMap);

        case 2:
          _visitorCustomIdMap = _context.sent;
          _context.next = 5;
          return put(propsActions.setPropertyVisitorCustomIdMap(_extends({}, _visitorCustomIdMap, (_extends2 = {}, _extends2[randomId] = uniqueId, _extends2))));

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$p);
}

function parseIncomingServerMessage(_ref) {
  var _extends3, _extends4;

  var payload, message, startChatData, startChatVisitorName, stateVisitorData, _serverIdsMap, serverIdsMap, historyLoaded, license, chatId, serverIdMap, foundId;

  return _regeneratorRuntime.wrap(function parseIncomingServerMessage$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          payload = _ref.payload;
          message = payload.message;
          message.timestamp *= 1000;
          _context2.t0 = message.name;
          _context2.next = _context2.t0 === START_CHAT ? 6 : _context2.t0 === SEND_MESSAGE ? 26 : _context2.t0 === IWCSMessageNames.RATE_CHAT ? 31 : _context2.t0 === CHAT_COMMENT ? 34 : _context2.t0 === CHAT_ATTACHMENT ? 37 : _context2.t0 === IWCSMessageNames.NEW_AGENT_MESSAGE ? 45 : _context2.t0 === IWCSMessageNames.AGENTS_OFFLINE ? 53 : _context2.t0 === IWCSMessageNames.CHAT_ENDED ? 53 : _context2.t0 === IWCSMessageNames.NEW_AGENT ? 69 : _context2.t0 === IWCSMessageNames.VISITOR_QUEUED ? 78 : _context2.t0 === IWCSMessageNames.TYPING_INDICATOR ? 81 : _context2.t0 === VISITOR_MESSAGE_SEEN ? 84 : _context2.t0 === IWCSMessageNames.INTEGRATION_DATA ? 96 : _context2.t0 === AGENT_MESSAGE_SEEN ? 99 : 111;
          break;

        case 6:
          _context2.next = 8;
          return select(propsSelectors.getPropertySecuredToken);

        case 8:
          _context2.t1 = _context2.sent;
          _context2.t2 = message.data.welcomeMessage;
          startChatData = {
            securedToken: _context2.t1,
            welcomeMessage: _context2.t2
          };
          startChatVisitorName = get('data.visitor.nick', message);
          _context2.next = 14;
          return select(getVisitorData);

        case 14:
          stateVisitorData = _context2.sent;

          if (!(startChatVisitorName && startChatVisitorName !== stateVisitorData.name)) {
            _context2.next = 18;
            break;
          }

          _context2.next = 18;
          return put(setVisitorData({
            visitorData: _extends({}, stateVisitorData, {
              name: startChatVisitorName
            }),
            internal: true
          }));

        case 18:
          if (message.data.visitorMessage) {
            startChatData.visitorMessage = {
              id: message.uniqueId,
              timestamp: message.timestamp,
              authorType: 'visitor',
              text: message.data.visitorMessage,
              customId: message.data.randomId
            };
          }

          _context2.next = 21;
          return put(propsActions.setPropertyChatId(undefined));

        case 21:
          _context2.next = 23;
          return put(chatStarted(startChatData));

        case 23:
          _context2.next = 25;
          return call(addIdToVisitorCustomIdMap, message.data.randomId, message.uniqueId);

        case 25:
          return _context2.abrupt("break", 112);

        case 26:
          _context2.next = 28;
          return call(addIdToVisitorCustomIdMap, message.data.randomId, message.uniqueId);

        case 28:
          _context2.next = 30;
          return put(newMessage({
            id: message.uniqueId,
            timestamp: message.timestamp,
            authorType: 'visitor',
            text: message.data.message,
            customId: message.data.randomId
          }));

        case 30:
          return _context2.abrupt("break", 112);

        case 31:
          _context2.next = 33;
          return put(rateChat({
            id: message.uniqueId,
            timestamp: message.timestamp,
            rate: message.data.rate,
            comment: message.data.comment
          }));

        case 33:
          return _context2.abrupt("break", 112);

        case 34:
          _context2.next = 36;
          return put(rateChat({
            id: message.uniqueId,
            timestamp: message.timestamp,
            comment: message.data.comment
          }));

        case 36:
          return _context2.abrupt("break", 112);

        case 37:
          _context2.next = 39;
          return select(propsSelectors.getPropertyServerIdsMap);

        case 39:
          _serverIdsMap = _context2.sent;
          _context2.next = 42;
          return put(propsActions.setPropertyServerIdsMap(_extends({}, _serverIdsMap, (_extends3 = {}, _extends3[message.uniqueId] = {
            serverId: message.data.attachmentToken,
            authorId: message.data.author.login
          }, _extends3))));

        case 42:
          _context2.next = 44;
          return put(newFile({
            id: message.uniqueId,
            timestamp: message.timestamp,
            authorId: message.data.author.login || 'visitor',
            authorType: message.data.author.type,
            url: message.data.files[0].url,
            size: message.data.files[0].size,
            contentType: message.data.files[0]['content-type'],
            attachmentToken: message.data.attachmentToken,
            thumbnail: message.data.files[0].thumbs
          }));

        case 44:
          return _context2.abrupt("break", 112);

        case 45:
          _context2.next = 47;
          return select(propsSelectors.getPropertyServerIdsMap);

        case 47:
          serverIdsMap = _context2.sent;
          _context2.next = 50;
          return put(propsActions.setPropertyServerIdsMap(_extends({}, serverIdsMap, (_extends4 = {}, _extends4[message.uniqueId] = {
            serverId: message.data.id,
            authorId: message.data.authorId
          }, _extends4))));

        case 50:
          _context2.next = 52;
          return put(newMessage({
            id: message.uniqueId,
            timestamp: message.timestamp,
            authorType: 'agent',
            text: message.data.message,
            isMobile: message.data.isMobile,
            authorId: message.data.authorId,
            serverId: message.data.id,
            json: message.data.json
          }));

        case 52:
          return _context2.abrupt("break", 112);

        case 53:
          _context2.next = 55;
          return put(chatEnded(message.data));

        case 55:
          _context2.next = 57;
          return put(propsActions.setPropertyChatState(NOT_CHATTING));

        case 57:
          _context2.next = 59;
          return select(propsSelectors.getPropertyHistoryLoaded);

        case 59:
          historyLoaded = _context2.sent;
          _context2.next = 62;
          return select(propsSelectors.getPropertyLicense);

        case 62:
          license = _context2.sent;
          storage$1.removeItem('securedToken');
          storage$1.removeOldSecretTokenCookie(license);

          if (historyLoaded) {
            _context2.next = 68;
            break;
          }

          _context2.next = 68;
          return put(propsActions.removePropertySecuredToken());

        case 68:
          return _context2.abrupt("break", 112);

        case 69:
          _context2.next = 71;
          return put(newAgent({
            id: message.data.id,
            name: message.data.name,
            jobTitle: message.data.jobTitle,
            avatarUrl: parseUrlToCdn(message.data.avatarUrl)
          }));

        case 71:
          _context2.next = 73;
          return select(propsSelectors.getPropertyChatId);

        case 73:
          chatId = _context2.sent;

          if (chatId) {
            _context2.next = 77;
            break;
          }

          _context2.next = 77;
          return put(propsActions.setPropertyChatId(message.data.chatId));

        case 77:
          return _context2.abrupt("break", 112);

        case 78:
          _context2.next = 80;
          return put(visitorQueued({
            numberInQueue: message.data.numberInQueue,
            waitingTime: message.data.waitingTime
          }));

        case 80:
          return _context2.abrupt("break", 112);

        case 81:
          _context2.next = 83;
          return put(typingIndicator({
            authorId: message.data.authorId,
            isTyping: message.data.isTyping
          }));

        case 83:
          return _context2.abrupt("break", 112);

        case 84:
          _context2.t3 = put;
          _context2.t4 = chatActions;
          _context2.next = 88;
          return select(propsSelectors.getPropertyVisitorCustomIdMap);

        case 88:
          _context2.t5 = message.data.id;
          _context2.t6 = _context2.sent[_context2.t5];
          _context2.t7 = message.data.id;
          _context2.t8 = {
            id: _context2.t6,
            customId: _context2.t7,
            type: 'visitor'
          };
          _context2.t9 = _context2.t4.messageSeen.call(_context2.t4, _context2.t8);
          _context2.next = 95;
          return (0, _context2.t3)(_context2.t9);

        case 95:
          return _context2.abrupt("break", 112);

        case 96:
          _context2.next = 98;
          return put(integrationData({
            id: String(message.uniqueId),
            timestamp: message.timestamp,
            integrationName: message.data.integrationName,
            data: message.data.data
          }));

        case 98:
          return _context2.abrupt("break", 112);

        case 99:
          _context2.next = 101;
          return select(propsSelectors.getPropertyServerIdsMap);

        case 101:
          serverIdMap = _context2.sent;
          foundId = null;

          if (serverIdMap) {
            _context2.next = 105;
            break;
          }

          return _context2.abrupt("break", 112);

        case 105:
          forOwn(function (item, id) {
            if (item.serverId === message.data.message.id) {
              foundId = id;
            }
          }, serverIdMap);

          if (foundId) {
            _context2.next = 108;
            break;
          }

          return _context2.abrupt("break", 112);

        case 108:
          _context2.next = 110;
          return put(messageSeen({
            id: foundId,
            customId: message.data.message.id,
            type: 'agent'
          }));

        case 110:
          return _context2.abrupt("break", 112);

        case 111:
          return _context2.abrupt("return");

        case 112:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$7);
}

function _callee$5() {
  var incomingMessageChannel, action;
  return _regeneratorRuntime.wrap(function _callee$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return actionChannel(incomingMessage.getActionName(), buffers.expanding());

        case 2:
          incomingMessageChannel = _context3.sent;

        case 3:

          _context3.next = 6;
          return take(incomingMessageChannel);

        case 6:
          action = _context3.sent;
          _context3.next = 9;
          return call(parseIncomingServerMessage, action);

        case 9:
          _context3.next = 3;
          break;

        case 11:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$5);
}

var _marked$q =
/*#__PURE__*/
_regeneratorRuntime.mark(pingersCaller),
    _marked2$8 =
/*#__PURE__*/
_regeneratorRuntime.mark(groupWatcher),
    _marked3$6 =
/*#__PURE__*/
_regeneratorRuntime.mark(rootSaga);
var restoreConnectionActions = [publicSendMessage, publicSendPrechatForm, publicStartChat, publicGetPredictedAgent, chatStarted].map(function (action) {
  return action.getActionName();
});

var turnOnClientLimitAction = function turnOnClientLimitAction(_ref) {
  var type = _ref.type,
      payload = _ref.payload;
  return type === propsActions.setPropertyClientLimitExceeded.getActionName() && payload.data === true;
};

var turnOffClientLimitAction = function turnOffClientLimitAction(_ref2) {
  var type = _ref2.type,
      payload = _ref2.payload;
  return type === propsActions.setPropertyClientLimitExceeded.getActionName() && payload.data === false;
};

function pingersCaller() {
  var chatPingerTask, statusPingerTask, pingerTask;
  return _regeneratorRuntime.wrap(function pingersCaller$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _safe(fork(_callee$4));

        case 2:
          chatPingerTask = _context.sent;

        case 3:

          _context.next = 6;
          return race([take(restoreConnectionActions), take(turnOffClientLimitAction)]);

        case 6:
          _context.next = 8;
          return _safe(fork(sendPing));

        case 8:
          statusPingerTask = _context.sent;
          _context.next = 11;
          return _safe(fork(_callee$2));

        case 11:
          pingerTask = _context.sent;
          _context.next = 14;
          return race([take(publicDisconnect.getActionName()), take(turnOnClientLimitAction)]);

        case 14:
          _context.next = 16;
          return put(propsActions.setPropertyPingSent(undefined));

        case 16:
          _context.next = 18;
          return cancel(statusPingerTask, chatPingerTask, pingerTask);

        case 18:
          _context.next = 3;
          break;

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked$q);
}

function groupWatcher() {
  var action, group, license;
  return _regeneratorRuntime.wrap(function groupWatcher$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:

          _context2.next = 3;
          return take(propsActions.setPropertyGroup);

        case 3:
          action = _context2.sent;
          group = action.payload.data;
          _context2.next = 7;
          return select(propsSelectors.getPropertyLicense);

        case 7:
          license = _context2.sent;
          storage$1.setPrefix("_livechat_" + license + "_" + group);
          _context2.next = 0;
          break;

        case 11:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2$8);
}

function rootSaga(_ref3) {
  var emitter, serverConfig, chatBetweenGroups;
  return _regeneratorRuntime.wrap(function rootSaga$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          emitter = _ref3.emitter, serverConfig = _ref3.serverConfig;
          _context3.next = 3;
          return select(propsSelectors.getPropertyChatBetweenGroups);

        case 3:
          chatBetweenGroups = _context3.sent;

          if (!(chatBetweenGroups === false)) {
            _context3.next = 7;
            break;
          }

          _context3.next = 7;
          return _safe(fork(groupWatcher));

        case 7:
          _context3.next = 9;
          return _safe(fork(_callee$1));

        case 9:
          _context3.next = 11;
          return _safe(fork(_callee$3, {
            emitter: emitter
          }));

        case 11:
          _context3.next = 13;
          return _safe(fork(_callee$5));

        case 13:
          _context3.next = 15;
          return _safe(fork(pingersCaller));

        case 15:
          _context3.next = 17;
          return call(_callee, serverConfig);

        case 17:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3$6);
}

var isBrowser = typeof document !== 'undefined';

var LISTENER_IDENTITY = 'LISTENER_IDENTITY';
var listenersMap = {};

var createDebuggedMethods = function createDebuggedMethods(methods, prefix) {
  if (prefix === void 0) {
    prefix = '';
  }

  var methodNames = Object.keys(methods);
  return methodNames.map(function (methodName) {
    var method = methods[methodName];
    return function () {
      var _console;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      (_console = console).info.apply(_console, [prefix + "." + methodName + "() ===>"].concat(args));

      var result = method.apply(void 0, args);

      if (result && typeof result.then === 'function') {
        result.then(function (data) {
          console.info(prefix + "." + methodName + "() <===", data);
        }).catch(function (err) {
          console.error(prefix + "." + methodName + "() <===", err);
        });
      }

      return result;
    };
  }).reduce(function (acc, method, index) {
    acc[methodNames[index]] = method;
    return acc;
  }, {});
};

var createEnhancedListener = function createEnhancedListener(label, event, listener) {
  if (listener[LISTENER_IDENTITY] === undefined) {
    Object.defineProperty(listener, LISTENER_IDENTITY, {
      value: {}
    });
  }

  if (listener[LISTENER_IDENTITY][event]) {
    var enhancedListenerId = listener[LISTENER_IDENTITY][event];
    return listenersMap[enhancedListenerId];
  }

  var enhancedListener = function enhancedListener(data) {
    console.info("." + label + "(\"" + event + "\") <===", data);
    listener(data);
  };

  var uniqueId = generateUniqueId(listenersMap);
  listener[LISTENER_IDENTITY][event] = uniqueId;
  listenersMap[uniqueId] = enhancedListener;
  return enhancedListener;
};

var debug = (function (sdk) {
  if (process.env.NODE_ENV === 'production') {
    console.warn('You probably do not want to use debug(visitorSDK) in your production environment.');
  }

  var _on = sdk.on,
      _off = sdk.off,
      rest = _objectWithoutPropertiesLoose(sdk, ["on", "off"]);

  var methods = createDebuggedMethods(rest);
  return Object.freeze(_extends({}, methods, {
    off: function off(event, listener) {
      console.info(".off(\"" + event + "\", " + (listener.name || 'anonymous') + ")");
      var enhancedListener = listener;

      if (listener[LISTENER_IDENTITY] !== undefined) {
        var enhancedListenerId = listener[LISTENER_IDENTITY][event];
        enhancedListener = listenersMap[enhancedListenerId];
      }

      _off(event, enhancedListener);
    },
    on: function on(event, listener) {
      _on(event, createEnhancedListener('on', event, listener));
    }
  }));
});

var KILOBYTE = 1024;
var MEGABYTE = 1024 * KILOBYTE;
var SIZE_LIMIT = 10 * MEGABYTE;

var sendMessage$1 = function sendMessage(store) {
  return function (_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        text = _ref.text,
        customId = _ref.customId,
        json = _ref.json;

    var sendMessagePromise = deferred();

    if (!text || !customId) {
      sendMessagePromise.reject({
        type: 'missing argument',
        reason: 'Missing text or customId parameter'
      });
      return sendMessagePromise.promise;
    }

    store.dispatch(publicSendMessage({
      customId: customId,
      text: text,
      json: json,
      promise: sendMessagePromise
    }));
    return sendMessagePromise.promise;
  };
};

var setSneakPeek = function setSneakPeek(store) {
  return function (_ref2) {
    var text = _ref2.text;
    var setSneakPeekPromise = deferred();
    store.dispatch(publicSetSneakPeek({
      text: text,
      promise: setSneakPeekPromise
    }));
    return setSneakPeekPromise.promise;
  };
};

var rateChat$2 = function rateChat(store) {
  return function (_temp2) {
    var _ref3 = _temp2 === void 0 ? {} : _temp2,
        rate = _ref3.rate,
        comment = _ref3.comment;

    var rateChatPromise = deferred();

    if (!rate && !comment) {
      rateChatPromise.reject({
        type: 'missing argument',
        reason: 'Missing rate parameter'
      });
      return rateChatPromise.promise;
    }

    if (rate && rate !== GOOD && rate !== NONE && rate !== BAD) {
      rateChatPromise.reject({
        type: 'wrong argument',
        reason: 'Rate argument should be equal "good", "bad" or "none"'
      });
      return rateChatPromise.promise;
    }

    store.dispatch(publicRateChat({
      rate: rate,
      comment: comment,
      promise: rateChatPromise
    }));
    return rateChatPromise.promise;
  };
};

var forwardChatTranscript = function forwardChatTranscript(store) {
  return function (_temp3) {
    var _ref4 = _temp3 === void 0 ? {} : _temp3,
        email = _ref4.email;

    var forwardChatTranscriptPromise = deferred();

    if (!email) {
      forwardChatTranscriptPromise.reject({
        type: 'missing argument',
        reason: 'Missing email parameter'
      });
      return forwardChatTranscriptPromise.promise;
    }

    store.dispatch(publicForwardChatTranscript({
      email: email,
      promise: forwardChatTranscriptPromise
    }));
    return forwardChatTranscriptPromise.promise;
  };
};

var closeChat$2 = function closeChat(store) {
  return function () {
    var closeChatPromise = deferred();
    store.dispatch(publicCloseChat({
      promise: closeChatPromise
    }));
    return closeChatPromise.promise;
  };
};

var disconnect = function disconnect(store) {
  return function () {
    var disconnectPromise = deferred();
    store.dispatch(publicDisconnect({
      promise: disconnectPromise
    }));
    return disconnectPromise.promise;
  };
};

var destroy = function destroy(rootTask, emitter) {
  return function () {
    emitter.off('*');
    rootTask.cancel();
  };
};

var getTicketForm$1 = function getTicketForm(store) {
  return function (_temp4) {
    var _ref5 = _temp4 === void 0 ? {} : _temp4,
        group = _ref5.group;

    var getTicketFormPromise = deferred();
    store.dispatch(publicGetTicketForm({
      promise: getTicketFormPromise,
      group: group
    }));
    return getTicketFormPromise.promise;
  };
};

var getTranslations$1 = function getTranslations(store) {
  return function () {
    var getTranslationsPromise = deferred();
    store.dispatch(publicGetTranslations({
      promise: getTranslationsPromise
    }));
    return getTranslationsPromise.promise;
  };
};

var sendFile$1 = function sendFile(store) {
  return function (_temp5) {
    var _ref6 = _temp5 === void 0 ? {} : _temp5,
        file = _ref6.file,
        onProgress = _ref6.onProgress;

    var requestId = String(Math.random());
    var sendFilePromise = deferred();

    if (!file) {
      sendFilePromise.reject({
        type: 'missing argument',
        reason: 'Missing file'
      });
      return sendFilePromise.promise;
    }

    if (file.size > SIZE_LIMIT) {
      sendFilePromise.reject({
        type: 'wrong argument',
        reason: 'Cannot upload a file over 10MB'
      });
      return sendFilePromise.promise;
    }

    store.dispatch(publicSendFile({
      file: file,
      customId: requestId,
      promise: sendFilePromise,
      onProgress: onProgress
    }));
    var promise = {
      then: function then(onResolve, onReject) {
        return sendFilePromise.promise.then(onResolve, onReject);
      },
      catch: function _catch(onReject) {
        return sendFilePromise.promise.catch(onReject);
      },
      cancel: function cancel$$1() {
        store.dispatch(publicCancelSendFile({
          customId: requestId
        }));
      }
    };
    return promise;
  };
};

var sendTicketForm$1 = function sendTicketForm(store) {
  return function (answers) {
    if (answers === void 0) {
      answers = {};
    }

    var sendTicketFormPromise = deferred();
    store.dispatch(publicSendTicketForm({
      answers: answers,
      promise: sendTicketFormPromise
    }));
    return sendTicketFormPromise.promise;
  };
};

var setVisitorData$1 = function setVisitorData(store) {
  return function (_temp6) {
    var _ref7 = _temp6 === void 0 ? {} : _temp6,
        name = _ref7.name,
        email = _ref7.email,
        customProperties = _ref7.customProperties,
        pageUrl = _ref7.pageUrl,
        pageTitle = _ref7.pageTitle,
        update = _ref7.update;

    var setVistiorDataPromise = deferred();

    if (!name && !email && !customProperties && !pageUrl && !pageTitle) {
      setVistiorDataPromise.reject({
        type: 'missing argument',
        reason: 'Missing name, email, url or customProperties'
      });
      return setVistiorDataPromise.promise;
    }

    store.dispatch(publicSetVisitorData({
      name: name,
      email: email,
      customProperties: customProperties,
      pageUrl: pageUrl,
      pageTitle: pageTitle,
      update: update,
      promise: setVistiorDataPromise
    }));
    return setVistiorDataPromise.promise;
  };
};

var getVisitorData$1 = function getVisitorData(store) {
  return function () {
    var getVisitorDataPromise = deferred();
    store.dispatch(publicGetVisitorData({
      promise: getVisitorDataPromise
    }));
    return getVisitorDataPromise.promise;
  };
};

var getPrechatForm = function getPrechatForm(store) {
  return function () {
    var getPrechatFormPromise = deferred();
    store.dispatch(publicGetPrechatForm({
      promise: getPrechatFormPromise
    }));
    return getPrechatFormPromise.promise;
  };
};

var sendPrechatForm = function sendPrechatForm(store) {
  return function (answers) {
    if (answers === void 0) {
      answers = {};
    }

    var sendPrechatFormPromise = deferred();
    store.dispatch(publicSendPrechatForm({
      promise: sendPrechatFormPromise,
      answers: answers
    }));
    return sendPrechatFormPromise.promise;
  };
};

var getPredictedAgent$1 = function getPredictedAgent(store) {
  return function () {
    var getPredictedAgentPromise = deferred();
    store.dispatch(publicGetPredictedAgent({
      promise: getPredictedAgentPromise
    }));
    return getPredictedAgentPromise.promise;
  };
};

var getPostChatForm = function getPostChatForm(store) {
  return function () {
    var getPostChatFormPromise = deferred();
    store.dispatch(publicGetPostChatForm({
      promise: getPostChatFormPromise
    }));
    return getPostChatFormPromise.promise;
  };
};

var sendPostChatForm = function sendPostChatForm(store) {
  return function (answers) {
    if (answers === void 0) {
      answers = {};
    }

    var sendPostChatFormPromise = deferred();
    store.dispatch(publicSendPostChatForm({
      promise: sendPostChatFormPromise,
      answers: answers
    }));
    return sendPostChatFormPromise.promise;
  };
};

var getConfig = function getConfig(store) {
  return function () {
    var getConfigPromise = deferred();
    store.dispatch(publicGetConfig({
      promise: getConfigPromise
    }));
    return getConfigPromise.promise;
  };
};

var acceptInvitation = function acceptInvitation(store) {
  return function (id) {
    var acceptInvitationPromise = deferred();
    store.dispatch(publicAcceptInvitation({
      id: id,
      promise: acceptInvitationPromise
    }));
    return acceptInvitation.promise;
  };
};

var markMessageAsSeen$1 = function markMessageAsSeen(store) {
  return function (messageId) {
    var markMessageAsSeenPromise = deferred();
    store.dispatch(publicMarkMessageAsSeen({
      promise: markMessageAsSeenPromise,
      messageId: messageId
    }));
    return markMessageAsSeenPromise.promise;
  };
};

var startChat$1 = function startChat(store) {
  return function () {
    var startChatPromise = deferred();
    store.dispatch(publicStartChat({
      promise: startChatPromise
    }));
    return startChatPromise.promise;
  };
};

var checkGroupStatus = function checkGroupStatus(store) {
  return function (group) {
    var parsedGroup = typeof group !== 'undefined' ? parseInt(group, 10) : undefined;
    var checkGroupStatusPromise = deferred();
    store.dispatch(publicCheckGroupStatus({
      promise: checkGroupStatusPromise,
      group: parsedGroup
    }));
    return checkGroupStatusPromise.promise;
  };
};

var setVisitorGroup = function setVisitorGroup(store) {
  return function (group) {
    store.dispatch(publicSetVisitorGroup({
      group: parseInt(group, 10)
    }));
  };
};

var calculateChatBetweenGroups = function calculateChatBetweenGroups(serverConfig) {
  if (serverConfig === void 0) {
    serverConfig = {};
  }

  if (serverConfig.__lc && serverConfig.__lc.chat_between_groups === false) {
    return false;
  }

  var location = get('location.href', isBrowser && document);
  var queryParams = location && getQueryParams(location);

  if (queryParams && queryParams.unique_groups === '1' || queryParams.unique_group === '1') {
    return false;
  }

  return true;
};

var getQueueForm$1 = function getQueueForm(store) {
  return function () {
    var getQueueFormPromise = deferred();
    store.dispatch(publicGetQueueForm({
      promise: getQueueFormPromise
    }));
    return getQueueFormPromise.promise;
  };
};
var init = function init(_temp7, serverConfig) {
  var _initialState;

  var _ref8 = _temp7 === void 0 ? {} : _temp7,
      license = _ref8.license,
      group = _ref8.group,
      _ref8$environment = _ref8.environment,
      environment = _ref8$environment === void 0 ? PRODUCTION : _ref8$environment,
      _ref8$page = _ref8.page,
      page = _ref8$page === void 0 ? {} : _ref8$page,
      _ref8$visitor = _ref8.visitor,
      visitor = _ref8$visitor === void 0 ? {} : _ref8$visitor,
      region = _ref8.region,
      _ref8$external = _ref8.external,
      external = _ref8$external === void 0 ? true : _ref8$external,
      _ref8$mobile = _ref8.mobile,
      mobile = _ref8$mobile === void 0 ? false : _ref8$mobile;

  if (!license) {
    throw new Error('Missing license parameter');
  }

  if (environment !== PRODUCTION && environment !== LABS && environment !== STAGING) {
    throw new Error('Wrong environment parameter');
  }

  var emitter = mitt();
  var originalEmit = emitter.emit;
  var emitCalls = [];

  emitter.emit = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    emitCalls.push(args);
  }; // force async 💩 so sdk subscribers have chance to subscribe to events


  setTimeout(function () {
    emitter.emit = originalEmit;
    emitCalls.forEach(function (args) {
      emitter.emit.apply(emitter, args);
    });
    emitCalls = null;
  }, 0);
  var sessionId = String(Math.random());
  var chatBetweenGroups = calculateChatBetweenGroups(serverConfig);

  if (chatBetweenGroups) {
    storage$1.setPrefix("_livechat_" + license);
  } else {
    storage$1.setPrefix("_livechat_" + license + "_" + group);
  }

  var initialState = (_initialState = {
    environment: environment
  }, _initialState[propsConstants.LICENSE] = license, _initialState[propsConstants.GROUP] = group, _initialState[propsConstants.SESSION_ID] = sessionId, _initialState[propsConstants.MOBILE] = mobile, _initialState.visitorData = {
    email: visitor.email || null,
    name: visitor.name || null,
    pageUrl: page.url || getOr('unknown', 'location.href', isBrowser && document),
    pageTitle: page.title || getOr('unknown', '0.innerHTML', isBrowser && document.getElementsByTagName('title') || {}),
    pageReferrer: page.referrer,
    customProperties: visitor.customProperties && !isEmpty(visitor.customProperties) ? visitor.customProperties : null
  }, _initialState[propsConstants.SECURED_TOKEN] = storage$1.getItem('securedToken') || get$1("secret_token_" + license), _initialState[propsConstants.SECRET_ID] = storage$1.getItem('secretId'), _initialState[propsConstants.CHAT_BETWEEN_GROUPS] = chatBetweenGroups, _initialState);

  if (region) {
    initialState[propsConstants.REGION] = region;
  }

  var store = configureStore(initialState, {
    external: external
  });
  var visitorId = storage$1.getItem('visitorId');

  if (visitorId) {
    store.dispatch(propsActions.setPropertyVisitorId(visitorId));
  }

  var rootTask = store.runSaga(rootSaga, {
    emitter: emitter,
    serverConfig: serverConfig
  });
  return {
    sendMessage: sendMessage$1(store),
    setSneakPeek: setSneakPeek(store),
    setVisitorData: setVisitorData$1(store),
    getVisitorData: getVisitorData$1(store),
    rateChat: rateChat$2(store),
    forwardChatTranscript: forwardChatTranscript(store),
    closeChat: closeChat$2(store),
    disconnect: disconnect(store),
    getTicketForm: getTicketForm$1(store),
    getTranslations: getTranslations$1(store),
    sendTicketForm: sendTicketForm$1(store),
    sendFile: sendFile$1(store),
    on: emitter.on,
    off: emitter.off,
    destroy: destroy(rootTask, emitter),
    getPrechatForm: getPrechatForm(store),
    sendPrechatForm: sendPrechatForm(store),
    getPredictedAgent: getPredictedAgent$1(store),
    getPostChatForm: getPostChatForm(store),
    sendPostChatForm: sendPostChatForm(store),
    getConfig: getConfig(store),
    acceptInvitation: acceptInvitation(store),
    markMessageAsSeen: markMessageAsSeen$1(store),
    startChat: startChat$1(store),
    checkGroupStatus: checkGroupStatus(store),
    setVisitorGroup: setVisitorGroup(store),
    getQueueForm: getQueueForm$1(store)
  };
};

export { init, debug, parseServerConfig, createSendTicketFormResponse, getTicketFormRequestBody, translateForm, ensureTicketFormRequiredFields, sendPostToAPI };
